import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

/** Possible directions in which to order a list of items when provided an orderBy argument. */
export enum AccessibilityFeature {
  Blind = 'BLIND',
  Deaf = 'DEAF',
  Elderly = 'ELDERLY',
  Lowvision = 'LOWVISION',
  Wheelchair = 'WHEELCHAIR'
}

export type AppData = {
  __typename?: 'AppData';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  value: Scalars['JSON']['output'];
};

export type Auth = {
  __typename?: 'Auth';
  /** JWT access token */
  accessToken: Scalars['String']['output'];
  /** JWT refresh token */
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type Booking = {
  __typename?: 'Booking';
  code: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Date']['output'];
  payment?: Maybe<Payment>;
  qrCode: Scalars['String']['output'];
  tour: Tour;
  tourId: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Date']['output'];
  usages: Scalars['Int']['output'];
  usagesLeft: Scalars['Int']['output'];
};


export type BookingQrCodeArgs = {
  noUrl?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type BookingCountInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  tourId?: InputMaybe<Scalars['String']['input']>;
  voucher?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BookingTourCount = {
  __typename?: 'BookingTourCount';
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  texts: Scalars['JSON']['output'];
};

export type BookingsPaginatedModel = {
  __typename?: 'BookingsPaginatedModel';
  intitialPaginationDate: Scalars['Date']['output'];
  nodes?: Maybe<Array<Booking>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BookingsWithDownloadLink = {
  __typename?: 'BookingsWithDownloadLink';
  bookings: Array<Booking>;
  url: Scalars['String']['output'];
};

export type CloneContentByIdInput = {
  contentId: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  targetNuggetId: Scalars['String']['input'];
  tourModeId: Scalars['String']['input'];
};

export type ContactRequestInput = {
  device?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  requestType: ContactRequestType;
  subject: Scalars['String']['input'];
  text: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Possible reasons for contact requests. */
export enum ContactRequestType {
  Feedback = 'FEEDBACK',
  Idea = 'IDEA',
  Support = 'SUPPORT'
}

export type Content = {
  __typename?: 'Content';
  blockedBy: Array<ContentPartial>;
  blockedById?: Maybe<Scalars['String']['output']>;
  config: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  keyvisual?: Maybe<File>;
  order: Scalars['Int']['output'];
  partials: Array<ContentPartial>;
  section: TourPoi;
  sectionId: Scalars['String']['output'];
  style: Scalars['JSON']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  texts: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ContentNugget = {
  __typename?: 'ContentNugget';
  config: Scalars['JSON']['output'];
  content: Array<Content>;
  description?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  keyvisual?: Maybe<File>;
  order: Scalars['Int']['output'];
  section: ContentSection;
  sectionId: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  texts: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
};

export type ContentPartial = {
  __typename?: 'ContentPartial';
  animations: Scalars['JSON']['output'];
  config: Scalars['JSON']['output'];
  contentId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  id: Scalars['String']['output'];
  keyvisual?: Maybe<File>;
  order: Scalars['Int']['output'];
  properties: Scalars['JSON']['output'];
  style: Scalars['JSON']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  texts: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ContentResult = {
  __typename?: 'ContentResult';
  answer: Scalars['JSON']['output'];
  contentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
};

export type ContentSection = {
  __typename?: 'ContentSection';
  config: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  files: Array<File>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  inDemo: Scalars['Boolean']['output'];
  keyvisual?: Maybe<File>;
  nuggets: Array<ContentNugget>;
  order: Scalars['Int']['output'];
  poi: TourPoi;
  poiId: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  texts: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type CoordinatesInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type CreateAppDataInput = {
  key: Scalars['String']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
};

export type CreateContentInput = {
  blockedById?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  nuggetId: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<Scalars['String']['input']>;
  texts: Array<TranslatableTextInput>;
  type: Scalars['String']['input'];
};

export type CreateContentNuggetInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  sectionId: Scalars['String']['input'];
  texts: Array<TranslatableTextInput>;
};

export type CreateContentResultInput = {
  answer?: InputMaybe<Scalars['JSON']['input']>;
  contentId: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContentSectionInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  poiId: Scalars['String']['input'];
  texts: Array<TranslatableTextInput>;
};

export type CreateCustomerGroupInput = {
  name: Scalars['String']['input'];
  tourIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateInAppPurchaseInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  receipt: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
};

export type CreateRatingInput = {
  name: Scalars['String']['input'];
  reaction?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  tourModeId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type CreateTagInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  key: Scalars['String']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTourInput = {
  price: Scalars['Float']['input'];
  status?: InputMaybe<TourStatus>;
  texts: Array<TranslatableTextInput>;
};

export type CreateTourModeInput = {
  ageFrom: Scalars['Int']['input'];
  ageTo: Scalars['Int']['input'];
  config?: InputMaybe<Scalars['JSON']['input']>;
  distance: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  texts: Array<TranslatableTextInput>;
  theme?: InputMaybe<Scalars['JSON']['input']>;
  tourId: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTourPoiInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  texts: Array<TranslatableTextInput>;
  tourModeId: Scalars['String']['input'];
};

export type CreateUserInput = {
  email: Scalars['String']['input'];
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
  sendInvitation: Scalars['Boolean']['input'];
};

export type CustomerGroup = {
  __typename?: 'CustomerGroup';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tours: Array<Tour>;
};

export type File = {
  __typename?: 'File';
  config: Scalars['JSON']['output'];
  copyright?: Maybe<FileCopyright>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Date']['output'];
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  meta: Scalars['JSON']['output'];
  mimeType: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type FileCopyright = {
  __typename?: 'FileCopyright';
  author: Scalars['String']['output'];
  license?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type FileCopyrightInput = {
  author: Scalars['String']['input'];
  license?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type FileLocalization = {
  __typename?: 'FileLocalization';
  file: File;
  fileId: Scalars['String']['output'];
  lang: Scalars['String']['output'];
  meta: Scalars['JSON']['output'];
  url: Scalars['String']['output'];
};

export type FilterInput = {
  field: Scalars['String']['input'];
  operator: FilterOperator;
  type: FilterTypes;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

/** Filter operators for datatables */
export enum FilterOperator {
  Between = 'BETWEEN',
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  In = 'IN',
  Is = 'IS',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  Like = 'LIKE',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ',
  Nin = 'NIN',
  NotLike = 'NOT_LIKE'
}

/** Filter types for datatables */
export enum FilterTypes {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  Perimeter = 'PERIMETER',
  Select = 'SELECT',
  String = 'STRING'
}

export type ImportTranslationsResult = {
  __typename?: 'ImportTranslationsResult';
  added: Scalars['Int']['output'];
  unchanged: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateBooking: Booking;
  cancelPayment: Payment;
  checkoutWithPaypal: PaypalPaymentCheckout;
  checkoutWithStripe: StripePaymentCheckout;
  cloneContent: Content;
  cloneContentById: Content;
  cloneContentNugget: ContentNugget;
  cloneContentSection: ContentSection;
  cloneTourPoi: TourPoi;
  createAppData: AppData;
  createBooking: Booking;
  createBookings: BookingsWithDownloadLink;
  createContent: Content;
  createContentNugget: ContentNugget;
  createContentResult: Array<ContentResult>;
  createContentSection: ContentSection;
  createCustomerGroup: CustomerGroup;
  createFreeTourPayment: Payment;
  createInAppPurchase: Payment;
  createRating: Rating;
  createTag: Tag;
  createTagRelations: Scalars['Boolean']['output'];
  createText: Text;
  createTour: Tour;
  createTourMode: TourMode;
  createTourPoi: TourPoi;
  createUser: User;
  deleteAppData: Scalars['Boolean']['output'];
  deleteContent: Scalars['Boolean']['output'];
  deleteContentNugget: Scalars['Boolean']['output'];
  deleteContentResult: Scalars['Boolean']['output'];
  deleteContentSection: Scalars['Boolean']['output'];
  deleteFile: File;
  deleteFileLocalization: FileLocalization;
  deleteFiles: Scalars['Boolean']['output'];
  deleteText: Text;
  deleteTour: Scalars['Boolean']['output'];
  deleteTourMode: Scalars['Boolean']['output'];
  deleteTourPoi: Scalars['Boolean']['output'];
  deleteTranslation: Text;
  deleteTranslations: Array<Text>;
  deleteUser: User;
  disconnectTags: Scalars['Boolean']['output'];
  disconnectTourPoi: Scalars['Boolean']['output'];
  executePaypalPayment?: Maybe<Scalars['String']['output']>;
  forgotPassword: Scalars['Boolean']['output'];
  fullfilPayment: Payment;
  importTour: Tour;
  importTranslations: ImportTranslationsResult;
  inviteUser: User;
  login: Auth;
  logout: Scalars['Boolean']['output'];
  passwordTokenValid: Scalars['Boolean']['output'];
  publishTourModeUpdate: TourModeDownload;
  refreshToken: Token;
  reorderContentNuggets: Array<ContentNugget>;
  reorderContentSections: Array<ContentSection>;
  reorderContents: Array<Content>;
  reorderTourPois: Array<TourPoi>;
  replaceFileInOrder: File;
  requestContact: Scalars['Boolean']['output'];
  updateAppData: AppData;
  updateContent: Content;
  updateContentNugget: ContentNugget;
  updateContentSection: ContentSection;
  updateCustomerGroup: CustomerGroup;
  updateFileInfo: File;
  updateFileLocalization: FileLocalization;
  updatePassword: Scalars['Boolean']['output'];
  updatePoiTag: Tag;
  updateText: Text;
  updateTour: Tour;
  updateTourMode: TourMode;
  updateTourPoi: TourPoi;
  updateUser: User;
  uploadFile?: Maybe<File>;
  uploadFileLocalization: FileLocalization;
  validateBooking: Booking;
};


export type MutationActivateBookingArgs = {
  code: Scalars['String']['input'];
};


export type MutationCancelPaymentArgs = {
  id: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


export type MutationCheckoutWithPaypalArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  tourId: Scalars['String']['input'];
};


export type MutationCheckoutWithStripeArgs = {
  email: Scalars['String']['input'];
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  tourId: Scalars['String']['input'];
};


export type MutationCloneContentArgs = {
  contentId: Scalars['String']['input'];
};


export type MutationCloneContentByIdArgs = {
  data: CloneContentByIdInput;
};


export type MutationCloneContentNuggetArgs = {
  nuggetId: Scalars['String']['input'];
  targetSectionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCloneContentSectionArgs = {
  sectionId: Scalars['String']['input'];
  targetPoiId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCloneTourPoiArgs = {
  poiId: Scalars['String']['input'];
  tourModeId: Scalars['String']['input'];
};


export type MutationCreateAppDataArgs = {
  data: CreateAppDataInput;
};


export type MutationCreateBookingArgs = {
  tourId: Scalars['String']['input'];
  usages: Scalars['Int']['input'];
};


export type MutationCreateBookingsArgs = {
  bookingCount: Scalars['Int']['input'];
  tourId: Scalars['String']['input'];
  usages: Scalars['Int']['input'];
};


export type MutationCreateContentArgs = {
  data: CreateContentInput;
};


export type MutationCreateContentNuggetArgs = {
  data: CreateContentNuggetInput;
};


export type MutationCreateContentResultArgs = {
  data: CreateContentResultInput;
};


export type MutationCreateContentSectionArgs = {
  data: CreateContentSectionInput;
};


export type MutationCreateCustomerGroupArgs = {
  data: CreateCustomerGroupInput;
};


export type MutationCreateFreeTourPaymentArgs = {
  os?: InputMaybe<Scalars['String']['input']>;
  tourId: Scalars['String']['input'];
};


export type MutationCreateInAppPurchaseArgs = {
  data: CreateInAppPurchaseInput;
};


export type MutationCreateRatingArgs = {
  data: CreateRatingInput;
};


export type MutationCreateTagArgs = {
  data: CreateTagInput;
};


export type MutationCreateTagRelationsArgs = {
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationCreateTextArgs = {
  data: UpdateTextInput;
};


export type MutationCreateTourArgs = {
  data: CreateTourInput;
};


export type MutationCreateTourModeArgs = {
  data: CreateTourModeInput;
};


export type MutationCreateTourPoiArgs = {
  data: CreateTourPoiInput;
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
};


export type MutationDeleteAppDataArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteContentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteContentNuggetArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteContentResultArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteContentSectionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFileLocalizationArgs = {
  fileId: Scalars['String']['input'];
  lang: Scalars['String']['input'];
};


export type MutationDeleteFilesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteTextArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTourArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTourModeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTourPoiArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTranslationArgs = {
  key: Scalars['String']['input'];
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
};


export type MutationDeleteTranslationsArgs = {
  keys: Array<Scalars['String']['input']>;
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDisconnectTagsArgs = {
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationDisconnectTourPoiArgs = {
  id: Scalars['String']['input'];
  modeId: Scalars['String']['input'];
};


export type MutationExecutePaypalPaymentArgs = {
  payerId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  paypalPaymentId: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationFullfilPaymentArgs = {
  chargeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


export type MutationImportTourArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportTranslationsArgs = {
  file: Scalars['Upload']['input'];
  language: Scalars['String']['input'];
};


export type MutationInviteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationPasswordTokenValidArgs = {
  token: Scalars['String']['input'];
  type: PasswordTokenType;
};


export type MutationPublishTourModeUpdateArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefreshTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationReorderContentNuggetsArgs = {
  nuggetIds: Array<Scalars['String']['input']>;
};


export type MutationReorderContentSectionsArgs = {
  sectionIds: Array<Scalars['String']['input']>;
};


export type MutationReorderContentsArgs = {
  contentIds: Array<Scalars['String']['input']>;
};


export type MutationReorderTourPoisArgs = {
  poiIds: Array<Scalars['String']['input']>;
  tourModeId: Scalars['String']['input'];
};


export type MutationReplaceFileInOrderArgs = {
  data: UploadFileInput;
  file: Scalars['Upload']['input'];
};


export type MutationRequestContactArgs = {
  data: ContactRequestInput;
};


export type MutationUpdateAppDataArgs = {
  data: UpdateAppDataInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateContentArgs = {
  data: UpdateContentInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateContentNuggetArgs = {
  data: UpdateContentNuggetInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateContentSectionArgs = {
  data: UpdateContentSectionInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateCustomerGroupArgs = {
  data: UpdateCustomerGroupInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateFileInfoArgs = {
  data: UpdateFileInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateFileLocalizationArgs = {
  data: UploadFileLocalizationInput;
  file: Scalars['Upload']['input'];
};


export type MutationUpdatePasswordArgs = {
  data: UpdatePasswordInput;
};


export type MutationUpdatePoiTagArgs = {
  data: UpdateTagInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTextArgs = {
  data: UpdateTextInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTourArgs = {
  data: UpdateTourInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTourModeArgs = {
  data: UpdateTourModeInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateTourPoiArgs = {
  data: UpdateTourPoiInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
  id: Scalars['String']['input'];
};


export type MutationUploadFileArgs = {
  data: UploadFileInput;
  file?: InputMaybe<Scalars['Upload']['input']>;
};


export type MutationUploadFileLocalizationArgs = {
  data: UploadFileLocalizationInput;
  file: Scalars['Upload']['input'];
};


export type MutationValidateBookingArgs = {
  code: Scalars['String']['input'];
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderInput = {
  direction: OrderDirection;
  field: Scalars['String']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
  filter?: InputMaybe<Array<FilterInput>>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<OrderInput>;
};

export type PasswordToken = {
  __typename?: 'PasswordToken';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  token: Scalars['String']['output'];
  type: PasswordTokenType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
};

/** Password token type */
export enum PasswordTokenType {
  Invitation = 'INVITATION',
  ResetPassword = 'RESET_PASSWORD'
}

export type Payment = {
  __typename?: 'Payment';
  amount: Scalars['Float']['output'];
  booking?: Maybe<Booking>;
  bookingCode?: Maybe<Scalars['String']['output']>;
  chargeId?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Date']['output'];
  currency: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  paymentMethod: Scalars['String']['output'];
  status: PaymentStatus;
  tourId: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Date']['output'];
};

/** Payment status */
export enum PaymentStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type PaypalPaymentCheckout = {
  __typename?: 'PaypalPaymentCheckout';
  paymentId: Scalars['String']['output'];
  paymentSecret: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Permission = {
  __typename?: 'Permission';
  ability: Scalars['String']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  appData: Array<AppData>;
  appDataByKey?: Maybe<AppData>;
  booking: Booking;
  bookingsCount: Array<BookingTourCount>;
  bookingsPaginated: BookingsPaginatedModel;
  canUpdateTourMode: Scalars['Boolean']['output'];
  content: Content;
  contentNugget: ContentNugget;
  contentResult: Array<ContentResult>;
  contentSection: ContentSection;
  customerGroup: CustomerGroup;
  customerGroups: Array<CustomerGroup>;
  downloadTourMode: TourModeDownload;
  me: User;
  paymentMethods: Array<Scalars['String']['output']>;
  searchTourContent: Array<TourSearchResult>;
  tag: Tag;
  tagByRelation: Tag;
  tags: Array<Tag>;
  tagsByModel: Array<Tag>;
  tour: Tour;
  tourByKey: Tour;
  tourMode: TourMode;
  tourPoi: TourPoi;
  tours: Array<Tour>;
};


export type QueryAppDataArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAppDataByKeyArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookingArgs = {
  code: Scalars['String']['input'];
};


export type QueryBookingsCountArgs = {
  data?: InputMaybe<BookingCountInput>;
};


export type QueryBookingsPaginatedArgs = {
  data: PaginationInput;
  tourId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCanUpdateTourModeArgs = {
  id: Scalars['String']['input'];
};


export type QueryContentArgs = {
  id: Scalars['String']['input'];
};


export type QueryContentNuggetArgs = {
  id: Scalars['String']['input'];
};


export type QueryContentResultArgs = {
  id: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentSectionArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryDownloadTourModeArgs = {
  id: Scalars['String']['input'];
  incremental?: InputMaybe<Scalars['Boolean']['input']>;
  maxSize?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchTourContentArgs = {
  query: Scalars['String']['input'];
  tourId: Scalars['String']['input'];
};


export type QueryTagArgs = {
  id: Scalars['String']['input'];
};


export type QueryTagByRelationArgs = {
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type QueryTagsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagsByModelArgs = {
  model?: InputMaybe<Scalars['String']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTourArgs = {
  id: Scalars['String']['input'];
};


export type QueryTourByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryTourModeArgs = {
  id: Scalars['String']['input'];
};


export type QueryTourPoiArgs = {
  id: Scalars['String']['input'];
};


export type QueryToursArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  userCoordinates?: InputMaybe<CoordinatesInput>;
};

export type Rating = {
  __typename?: 'Rating';
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reaction?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tourMode: TourMode;
  tourModeId: Scalars['String']['output'];
  user: User;
  userId?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type Role = {
  __typename?: 'Role';
  ancestorId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
};

export type StripePaymentCheckout = {
  __typename?: 'StripePaymentCheckout';
  customer: Scalars['String']['output'];
  ephemeralKey: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  paymentIntent: Scalars['String']['output'];
  paymentSecret: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  contentResultAdded: ContentResult;
  userCreated: User;
};


export type SubscriptionContentResultAddedArgs = {
  contentId: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  category?: Maybe<Scalars['String']['output']>;
  config?: Maybe<Scalars['JSON']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  texts: Scalars['JSON']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Date']['output'];
};

export type Text = {
  __typename?: 'Text';
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  model: Scalars['String']['output'];
  modelId: Scalars['String']['output'];
  translations: Array<Translation>;
};

export type Token = {
  __typename?: 'Token';
  /** JWT access token */
  accessToken: Scalars['String']['output'];
  /** JWT refresh token */
  refreshToken: Scalars['String']['output'];
};

export type Tour = {
  __typename?: 'Tour';
  accessibilityFeatures: Array<AccessibilityFeature>;
  center?: Maybe<Coordinates>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Date']['output'];
  customerGroupId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  files: Array<File>;
  id: Scalars['ID']['output'];
  ignoreInAppOnAndroid: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  keyvisual?: Maybe<File>;
  mode: TourMode;
  modes: Array<TourMode>;
  numberOfRatings: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  rating: Scalars['Float']['output'];
  ratings: Array<Rating>;
  status: TourStatus;
  subtitle: Scalars['String']['output'];
  texts: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Date']['output'];
};


export type TourModeArgs = {
  id: Scalars['String']['input'];
};


export type TourRatingsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type TourMode = {
  __typename?: 'TourMode';
  accessibilityFeatures: Array<AccessibilityFeature>;
  ageFrom: Scalars['Int']['output'];
  ageTo: Scalars['Int']['output'];
  config: Scalars['JSON']['output'];
  contributors?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  distance: Scalars['Int']['output'];
  duration: Scalars['Int']['output'];
  files: Array<File>;
  id: Scalars['String']['output'];
  keyvisual?: Maybe<File>;
  languages: Array<Scalars['String']['output']>;
  poiCount: Scalars['Int']['output'];
  pois: Array<TourPoi>;
  requiredAppVersion: Scalars['String']['output'];
  texts: Scalars['JSON']['output'];
  theme: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  tour: Tour;
  tourId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  version: Scalars['String']['output'];
};


export type TourModePoisArgs = {
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type TourModeDownload = {
  __typename?: 'TourModeDownload';
  filesize: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type TourPoi = {
  __typename?: 'TourPoi';
  config: Scalars['JSON']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  files: Array<File>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inDemo: Scalars['Boolean']['output'];
  keyvisual?: Maybe<File>;
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  order: Scalars['Int']['output'];
  sections: Array<ContentSection>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tags: Array<Tag>;
  texts: Scalars['JSON']['output'];
  title: Scalars['String']['output'];
  tourModeId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Date']['output'];
};

export type TourSearchResult = {
  __typename?: 'TourSearchResult';
  breadcrumb: Scalars['String']['output'];
  contentId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  matchedKey: Scalars['String']['output'];
  modeId: Scalars['String']['output'];
  nuggetId?: Maybe<Scalars['String']['output']>;
  poiId: Scalars['String']['output'];
  sectionId: Scalars['String']['output'];
  snippet: Scalars['String']['output'];
};

/** Tour status */
export enum TourStatus {
  Draft = 'DRAFT',
  Private = 'PRIVATE',
  Published = 'PUBLISHED'
}

export type TranslatableTextInput = {
  key: Scalars['String']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Translation = {
  __typename?: 'Translation';
  lang: Scalars['String']['output'];
  textId: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UpdateAppDataInput = {
  key: Scalars['String']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['JSON']['input'];
};

export type UpdateContentInput = {
  blockedById?: InputMaybe<Scalars['String']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  nuggetId: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  style?: InputMaybe<Scalars['JSON']['input']>;
  texts: Array<TranslatableTextInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContentNuggetInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  sectionId: Scalars['String']['input'];
  texts: Array<TranslatableTextInput>;
};

export type UpdateContentSectionInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  poiId: Scalars['String']['input'];
  texts: Array<TranslatableTextInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  tourIds?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFileInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  copyright?: InputMaybe<FileCopyrightInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type UpdateTagInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  key: Scalars['String']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateTextInput = {
  key: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type UpdateTourInput = {
  customerGroupId?: InputMaybe<Array<Scalars['String']['input']>>;
  price: Scalars['Float']['input'];
  status?: InputMaybe<TourStatus>;
  texts?: InputMaybe<Array<TranslatableTextInput>>;
};

export type UpdateTourModeInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  contributors?: InputMaybe<Scalars['String']['input']>;
  distance?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  texts?: InputMaybe<Array<TranslatableTextInput>>;
  theme?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTourPoiInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
  texts?: InputMaybe<Array<TranslatableTextInput>>;
  type: Scalars['String']['input'];
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFileInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  copyright?: InputMaybe<FileCopyrightInput>;
  keepFileType?: InputMaybe<Scalars['Boolean']['input']>;
  key: Scalars['String']['input'];
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  replace?: InputMaybe<Scalars['Boolean']['input']>;
  replaceId?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFileLocalizationInput = {
  fileId: Scalars['String']['input'];
  lang: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitation?: Maybe<PasswordToken>;
  lastname: Scalars['String']['output'];
  registered: Scalars['Boolean']['output'];
  role: Role;
  roleId: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['Date']['output'];
};

export type LoginMutationVariables = Exact<{
  data: LoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'Auth', accessToken: string, refreshToken: string, user: { __typename?: 'User', id: string, firstname: string, lastname: string, email: string, role: { __typename?: 'Role', name: string, permissions: Array<{ __typename?: 'Permission', ability: string, resource: string }> } } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type RefreshTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'Token', accessToken: string, refreshToken: string } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword: boolean };

export type UpdatePasswordMutationVariables = Exact<{
  data: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export type PasswordTokenValidMutationVariables = Exact<{
  token: Scalars['String']['input'];
  type: PasswordTokenType;
}>;


export type PasswordTokenValidMutation = { __typename?: 'Mutation', passwordTokenValid: boolean };

export type BookingsMinimalFragment = { __typename?: 'Booking', code: string, usages: number, usagesLeft: number, createdAt: Date, payment?: { __typename?: 'Payment', id: string, paymentMethod: string, status: PaymentStatus, amount: number, chargeId?: string | null, currency: string, email: string, name?: string | null } | null };

export type BookingQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type BookingQuery = { __typename?: 'Query', booking: { __typename?: 'Booking', code: string, usages: number, usagesLeft: number, createdAt: Date, payment?: { __typename?: 'Payment', id: string, paymentMethod: string, status: PaymentStatus, amount: number, chargeId?: string | null, currency: string, email: string, name?: string | null } | null } };

export type BookingsPaginatedQueryVariables = Exact<{
  data: PaginationInput;
  tourId?: InputMaybe<Scalars['String']['input']>;
}>;


export type BookingsPaginatedQuery = { __typename?: 'Query', bookingsPaginated: { __typename?: 'BookingsPaginatedModel', totalCount: number, nodes?: Array<{ __typename?: 'Booking', code: string, usages: number, usagesLeft: number, createdAt: Date, tour: { __typename?: 'Tour', title: string }, payment?: { __typename?: 'Payment', id: string, paymentMethod: string, status: PaymentStatus, amount: number, chargeId?: string | null, currency: string, email: string, name?: string | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', currentPage: number, totalPages: number, perPage: number } } };

export type BookingsCountQueryVariables = Exact<{
  data?: InputMaybe<BookingCountInput>;
}>;


export type BookingsCountQuery = { __typename?: 'Query', bookingsCount: Array<{ __typename?: 'BookingTourCount', id: string, count: number, percentage: number, texts: any }> };

export type CreateBookingsMutationVariables = Exact<{
  tourId: Scalars['String']['input'];
  bookingCount: Scalars['Int']['input'];
  usages: Scalars['Int']['input'];
}>;


export type CreateBookingsMutation = { __typename?: 'Mutation', createBookings: { __typename?: 'BookingsWithDownloadLink', url: string, bookings: Array<{ __typename?: 'Booking', code: string }> } };

export type PartialDataFragment = { __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> };

export type ContentDataFragment = { __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> };

export type ContentQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ContentQuery = { __typename?: 'Query', content: { __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type UpdateContentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateContentInput;
}>;


export type UpdateContentMutation = { __typename?: 'Mutation', updateContent: { __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type CreateContentMutationVariables = Exact<{
  data: CreateContentInput;
}>;


export type CreateContentMutation = { __typename?: 'Mutation', createContent: { __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type CloneContentByIdMutationVariables = Exact<{
  data: CloneContentByIdInput;
}>;


export type CloneContentByIdMutation = { __typename?: 'Mutation', cloneContentById: { __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type CloneContentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CloneContentMutation = { __typename?: 'Mutation', cloneContent: { __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type DeleteContentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteContentMutation = { __typename?: 'Mutation', deleteContent: boolean };

export type ReorderContentMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReorderContentMutation = { __typename?: 'Mutation', reorderContents: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> };

export type CustomerGroupDataFragment = { __typename?: 'CustomerGroup', id: string, name: string, tours: Array<{ __typename?: 'Tour', id: string, title: string, subtitle: string, rating: number, keyvisual?: { __typename?: 'File', url: string } | null }> };

export type CustomerGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerGroupsQuery = { __typename?: 'Query', customerGroups: Array<{ __typename?: 'CustomerGroup', id: string, name: string, tours: Array<{ __typename?: 'Tour', id: string, title: string, subtitle: string, rating: number, keyvisual?: { __typename?: 'File', url: string } | null }> }> };

export type FileDataFragment = { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null };

export type UploadFileMutationVariables = Exact<{
  data: UploadFileInput;
  file?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null };

export type ReplaceFileInOrderMutationVariables = Exact<{
  data: UploadFileInput;
  file: Scalars['Upload']['input'];
}>;


export type ReplaceFileInOrderMutation = { __typename?: 'Mutation', replaceFileInOrder: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } };

export type UpdateFileMutationVariables = Exact<{
  data: UpdateFileInput;
  id: Scalars['String']['input'];
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateFileInfo: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } };

export type DeleteFileMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } };

export type ContentNuggetDataFragment = { __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> };

export type ContentNuggetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ContentNuggetQuery = { __typename?: 'Query', contentNugget: { __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> } };

export type UpdateContentNuggetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateContentNuggetInput;
}>;


export type UpdateContentNuggetMutation = { __typename?: 'Mutation', updateContentNugget: { __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> } };

export type CreateContentNuggetMutationVariables = Exact<{
  data: CreateContentNuggetInput;
}>;


export type CreateContentNuggetMutation = { __typename?: 'Mutation', createContentNugget: { __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> } };

export type CloneContentNuggetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  targetSectionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloneContentNuggetMutation = { __typename?: 'Mutation', cloneContentNugget: { __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> } };

export type ReorderContentNuggetsMutationVariables = Exact<{
  nuggetIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReorderContentNuggetsMutation = { __typename?: 'Mutation', reorderContentNuggets: Array<{ __typename?: 'ContentNugget', id: string, order: number }> };

export type DeleteContentNuggetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteContentNuggetMutation = { __typename?: 'Mutation', deleteContentNugget: boolean };

export type PaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodsQuery = { __typename?: 'Query', paymentMethods: Array<string> };

export type PoiTagDataFragment = { __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null };

export type TourPoiFullFragment = { __typename?: 'TourPoi', id: string, title: string, subtitle?: string | null, description?: string | null, texts: any, type: string, lat: number, lng: number, order: number, config: any, hidden: boolean, tags: Array<{ __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, sections: Array<{ __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> }> };

export type TourPoiQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TourPoiQuery = { __typename?: 'Query', tourPoi: { __typename?: 'TourPoi', id: string, title: string, subtitle?: string | null, description?: string | null, texts: any, type: string, lat: number, lng: number, order: number, config: any, hidden: boolean, tags: Array<{ __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, sections: Array<{ __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> }> } };

export type UpdateTourPoiMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateTourPoiInput;
}>;


export type UpdateTourPoiMutation = { __typename?: 'Mutation', updateTourPoi: { __typename?: 'TourPoi', id: string, title: string, subtitle?: string | null, description?: string | null, texts: any, type: string, lat: number, lng: number, order: number, config: any, hidden: boolean, tags: Array<{ __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, sections: Array<{ __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> }> } };

export type CreateTourPoiMutationVariables = Exact<{
  data: CreateTourPoiInput;
}>;


export type CreateTourPoiMutation = { __typename?: 'Mutation', createTourPoi: { __typename?: 'TourPoi', id: string, title: string, subtitle?: string | null, description?: string | null, texts: any, type: string, lat: number, lng: number, order: number, config: any, hidden: boolean, tags: Array<{ __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, sections: Array<{ __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> }> } };

export type CloneTourPoiMutationVariables = Exact<{
  poiId: Scalars['String']['input'];
  tourModeId: Scalars['String']['input'];
}>;


export type CloneTourPoiMutation = { __typename?: 'Mutation', cloneTourPoi: { __typename?: 'TourPoi', id: string, title: string, subtitle?: string | null, description?: string | null, texts: any, type: string, lat: number, lng: number, order: number, config: any, hidden: boolean, tags: Array<{ __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, sections: Array<{ __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> }> } };

export type DeleteTourPoiMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTourPoiMutation = { __typename?: 'Mutation', deleteTourPoi: boolean };

export type DisconnectTourPoiMutationVariables = Exact<{
  id: Scalars['String']['input'];
  modeId: Scalars['String']['input'];
}>;


export type DisconnectTourPoiMutation = { __typename?: 'Mutation', disconnectTourPoi: boolean };

export type ReorderTourPoisMutationVariables = Exact<{
  poiIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  tourModeId: Scalars['String']['input'];
}>;


export type ReorderTourPoisMutation = { __typename?: 'Mutation', reorderTourPois: Array<{ __typename?: 'TourPoi', id: string }> };

export type SearchTourContentQueryVariables = Exact<{
  tourId: Scalars['String']['input'];
  query: Scalars['String']['input'];
}>;


export type SearchTourContentQuery = { __typename?: 'Query', searchTourContent: Array<{ __typename?: 'TourSearchResult', id: string, kind: string, modeId: string, poiId: string, sectionId: string, nuggetId?: string | null, contentId?: string | null, contentType?: string | null, matchedKey: string, snippet: string, breadcrumb: string }> };

export type ContentSectionFullFragment = { __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> };

export type UpdateContentSectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateContentSectionInput;
}>;


export type UpdateContentSectionMutation = { __typename?: 'Mutation', updateContentSection: { __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> } };

export type CreateContentSectionMutationVariables = Exact<{
  data: CreateContentSectionInput;
}>;


export type CreateContentSectionMutation = { __typename?: 'Mutation', createContentSection: { __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> } };

export type CloneContentSectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  targetPoiId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CloneContentSectionMutation = { __typename?: 'Mutation', cloneContentSection: { __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> } };

export type ReorderContentSectionsMutationVariables = Exact<{
  sectionIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReorderContentSectionsMutation = { __typename?: 'Mutation', reorderContentSections: Array<{ __typename?: 'ContentSection', id: string, order: number }> };

export type DeleteContentSectionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteContentSectionMutation = { __typename?: 'Mutation', deleteContentSection: boolean };

export type TagQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TagQuery = { __typename?: 'Query', tag: { __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null } };

export type TagsQueryVariables = Exact<{
  key?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null }> };

export type CreateTagMutationVariables = Exact<{
  data: CreateTagInput;
}>;


export type CreateTagMutation = { __typename?: 'Mutation', createTag: { __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null } };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updatePoiTag: { __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null } };

export type CreateTagRelationsMutationVariables = Exact<{
  tagIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type CreateTagRelationsMutation = { __typename?: 'Mutation', createTagRelations: boolean };

export type DisconnectTagsMutationVariables = Exact<{
  tagIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type DisconnectTagsMutation = { __typename?: 'Mutation', disconnectTags: boolean };

export type DeleteTranslationMutationVariables = Exact<{
  key: Scalars['String']['input'];
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type DeleteTranslationMutation = { __typename?: 'Mutation', deleteTranslation: { __typename?: 'Text', id: string } };

export type DeleteTranslationsMutationVariables = Exact<{
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  model: Scalars['String']['input'];
  modelId: Scalars['String']['input'];
}>;


export type DeleteTranslationsMutation = { __typename?: 'Mutation', deleteTranslations: Array<{ __typename?: 'Text', id: string }> };

export type TourRatingMinimalFragment = { __typename?: 'Rating', id: string, text: string, title: string, value: number };

export type TourDataMinimalFragment = { __typename?: 'Tour', id: string, status: TourStatus, title: string, accessibilityFeatures: Array<AccessibilityFeature>, subtitle: string, description?: string | null, price: number, texts: any, rating: number, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, modes: Array<{ __typename?: 'TourMode', id: string, accessibilityFeatures: Array<AccessibilityFeature>, title: string, poiCount: number, distance: number, ageFrom: number, ageTo: number, duration: number, config: any, theme: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> };

export type TourDataPaymentFragment = { __typename?: 'Tour', id: string, price: number };

export type ToursQueryVariables = Exact<{ [key: string]: never; }>;


export type ToursQuery = { __typename?: 'Query', tours: Array<{ __typename?: 'Tour', id: string, status: TourStatus, title: string, accessibilityFeatures: Array<AccessibilityFeature>, subtitle: string, description?: string | null, price: number, texts: any, rating: number, ratings: Array<{ __typename?: 'Rating', id: string, text: string, title: string, value: number }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, modes: Array<{ __typename?: 'TourMode', id: string, accessibilityFeatures: Array<AccessibilityFeature>, title: string, poiCount: number, distance: number, ageFrom: number, ageTo: number, duration: number, config: any, theme: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> };

export type TourFullQueryVariables = Exact<{
  id: Scalars['String']['input'];
  modeId: Scalars['String']['input'];
}>;


export type TourFullQuery = { __typename?: 'Query', tour: { __typename?: 'Tour', id: string, status: TourStatus, title: string, subtitle: string, description?: string | null, texts: any, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, mode: { __typename?: 'TourMode', id: string, title: string, ageFrom: number, ageTo: number, duration: number, distance: number, contributors?: string | null, texts: any, config: any, theme: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, pois: Array<{ __typename?: 'TourPoi', id: string, title: string, subtitle?: string | null, description?: string | null, texts: any, type: string, lat: number, lng: number, order: number, config: any, hidden: boolean, tags: Array<{ __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, sections: Array<{ __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> }> }> } } };

export type TourQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TourQuery = { __typename?: 'Query', tour: { __typename?: 'Tour', id: string, status: TourStatus, title: string, accessibilityFeatures: Array<AccessibilityFeature>, subtitle: string, description?: string | null, price: number, texts: any, rating: number, ratings: Array<{ __typename?: 'Rating', id: string, text: string, title: string, value: number }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, modes: Array<{ __typename?: 'TourMode', id: string, accessibilityFeatures: Array<AccessibilityFeature>, title: string, poiCount: number, distance: number, ageFrom: number, ageTo: number, duration: number, config: any, theme: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type TourTitleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TourTitleQuery = { __typename?: 'Query', tour: { __typename?: 'Tour', id: string, title: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null } };

export type TourModeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TourModeQuery = { __typename?: 'Query', tourMode: { __typename?: 'TourMode', id: string, title: string, accessibilityFeatures: Array<AccessibilityFeature>, ageFrom: number, ageTo: number, duration: number, distance: number, contributors?: string | null, texts: any, config: any, theme: any, type: string, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, pois: Array<{ __typename?: 'TourPoi', id: string, title: string, subtitle?: string | null, description?: string | null, texts: any, type: string, lat: number, lng: number, order: number, config: any, hidden: boolean, tags: Array<{ __typename?: 'Tag', id: string, key: string, texts: any, config?: any | null }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, sections: Array<{ __typename?: 'ContentSection', id: string, config: any, order: number, title: string, hidden: boolean, poiId: string, texts: any, inDemo: boolean, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', order: number, id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, nuggets: Array<{ __typename?: 'ContentNugget', id: string, title: string, subtitle?: string | null, order: number, config: any, texts: any, hidden: boolean, sectionId: string, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, content: Array<{ __typename?: 'Content', id: string, type: string, order: number, hidden: boolean, config: any, style: any, texts: any, blockedById?: string | null, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }>, partials: Array<{ __typename?: 'ContentPartial', id: string, order: number, type: string, animations: any, config: any, properties: any, style: any, texts: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> }> }> }> }> } };

export type CreateTourMutationVariables = Exact<{
  data: CreateTourInput;
}>;


export type CreateTourMutation = { __typename?: 'Mutation', createTour: { __typename?: 'Tour', id: string, status: TourStatus, title: string, accessibilityFeatures: Array<AccessibilityFeature>, subtitle: string, description?: string | null, price: number, texts: any, rating: number, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, modes: Array<{ __typename?: 'TourMode', id: string, accessibilityFeatures: Array<AccessibilityFeature>, title: string, poiCount: number, distance: number, ageFrom: number, ageTo: number, duration: number, config: any, theme: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type UpdateTourMutationVariables = Exact<{
  data: UpdateTourInput;
  id: Scalars['String']['input'];
}>;


export type UpdateTourMutation = { __typename?: 'Mutation', updateTour: { __typename?: 'Tour', id: string, status: TourStatus, title: string, accessibilityFeatures: Array<AccessibilityFeature>, subtitle: string, description?: string | null, price: number, texts: any, rating: number, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, modes: Array<{ __typename?: 'TourMode', id: string, accessibilityFeatures: Array<AccessibilityFeature>, title: string, poiCount: number, distance: number, ageFrom: number, ageTo: number, duration: number, config: any, theme: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type DeleteTourMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTourMutation = { __typename?: 'Mutation', deleteTour: boolean };

export type CreateTourModeMutationVariables = Exact<{
  data: CreateTourModeInput;
}>;


export type CreateTourModeMutation = { __typename?: 'Mutation', createTourMode: { __typename?: 'TourMode', id: string } };

export type UpdateTourModeMutationVariables = Exact<{
  data: UpdateTourModeInput;
  id: Scalars['String']['input'];
}>;


export type UpdateTourModeMutation = { __typename?: 'Mutation', updateTourMode: { __typename?: 'TourMode', id: string } };

export type CanUpdateTourModeQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CanUpdateTourModeQuery = { __typename?: 'Query', canUpdateTourMode: boolean };

export type PublishTourModeUpdateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PublishTourModeUpdateMutation = { __typename?: 'Mutation', publishTourModeUpdate: { __typename?: 'TourModeDownload', url: string, filesize: number } };

export type DeleteTourModeMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteTourModeMutation = { __typename?: 'Mutation', deleteTourMode: boolean };

export type ImportTourMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ImportTourMutation = { __typename?: 'Mutation', importTour: { __typename?: 'Tour', id: string, status: TourStatus, title: string, accessibilityFeatures: Array<AccessibilityFeature>, subtitle: string, description?: string | null, price: number, texts: any, rating: number, ratings: Array<{ __typename?: 'Rating', id: string, text: string, title: string, value: number }>, keyvisual?: { __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null } | null, modes: Array<{ __typename?: 'TourMode', id: string, accessibilityFeatures: Array<AccessibilityFeature>, title: string, poiCount: number, distance: number, ageFrom: number, ageTo: number, duration: number, config: any, theme: any, files: Array<{ __typename?: 'File', id: string, key: string, fileName: string, fileSize: number, config: any, createdAt: Date, mimeType: string, modelId: string, order: number, updatedAt: Date, url: string, copyright?: { __typename?: 'FileCopyright', author: string, license?: string | null, url?: string | null, year?: number | null } | null }> }> } };

export type ImportTranslationsMutationVariables = Exact<{
  language: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
}>;


export type ImportTranslationsMutation = { __typename?: 'Mutation', importTranslations: { __typename?: 'ImportTranslationsResult', added: number, updated: number, unchanged: number } };

export const BookingsMinimalFragmentDoc = gql`
    fragment BookingsMinimal on Booking {
  code
  usages
  usagesLeft
  createdAt
  payment {
    id
    paymentMethod
    status
    amount
    chargeId
    currency
    email
    name
  }
}
    `;
export const CustomerGroupDataFragmentDoc = gql`
    fragment CustomerGroupData on CustomerGroup {
  id
  name
  tours {
    id
    title
    keyvisual {
      url
    }
    subtitle
    rating
  }
}
    `;
export const PoiTagDataFragmentDoc = gql`
    fragment PoiTagData on Tag {
  id
  key
  texts
  config
}
    `;
export const FileDataFragmentDoc = gql`
    fragment FileData on File {
  id
  key
  fileName
  fileSize
  config
  createdAt
  mimeType
  modelId
  order
  updatedAt
  url
  copyright {
    author
    license
    url
    year
  }
}
    `;
export const PartialDataFragmentDoc = gql`
    fragment PartialData on ContentPartial {
  id
  order
  type
  animations
  config
  properties
  style
  files {
    ...FileData
  }
  style
  texts
}
    ${FileDataFragmentDoc}`;
export const ContentDataFragmentDoc = gql`
    fragment ContentData on Content {
  id
  type
  order
  files {
    ...FileData
  }
  hidden
  config
  style
  texts
  blockedById
  partials {
    ...PartialData
  }
}
    ${FileDataFragmentDoc}
${PartialDataFragmentDoc}`;
export const ContentNuggetDataFragmentDoc = gql`
    fragment ContentNuggetData on ContentNugget {
  id
  title
  subtitle
  order
  config
  texts
  hidden
  keyvisual {
    ...FileData
  }
  files {
    ...FileData
  }
  sectionId
  content {
    ...ContentData
  }
}
    ${FileDataFragmentDoc}
${ContentDataFragmentDoc}`;
export const ContentSectionFullFragmentDoc = gql`
    fragment ContentSectionFull on ContentSection {
  id
  config
  order
  title
  hidden
  keyvisual {
    ...FileData
  }
  files {
    ...FileData
    order
  }
  nuggets {
    ...ContentNuggetData
  }
  poiId
  texts
  inDemo
}
    ${FileDataFragmentDoc}
${ContentNuggetDataFragmentDoc}`;
export const TourPoiFullFragmentDoc = gql`
    fragment TourPoiFull on TourPoi {
  id
  title
  subtitle
  description
  texts
  type
  lat
  lng
  order
  config
  hidden
  tags {
    ...PoiTagData
  }
  keyvisual {
    ...FileData
  }
  files {
    ...FileData
  }
  sections {
    ...ContentSectionFull
  }
}
    ${PoiTagDataFragmentDoc}
${FileDataFragmentDoc}
${ContentSectionFullFragmentDoc}`;
export const TourRatingMinimalFragmentDoc = gql`
    fragment TourRatingMinimal on Rating {
  id
  text
  title
  value
}
    `;
export const TourDataMinimalFragmentDoc = gql`
    fragment TourDataMinimal on Tour {
  id
  status
  title
  accessibilityFeatures
  subtitle
  description
  price
  keyvisual {
    ...FileData
  }
  modes {
    id
    accessibilityFeatures
    title
    poiCount
    distance
    ageFrom
    ageTo
    duration
    config
    theme
    files {
      ...FileData
    }
  }
  texts
  rating
}
    ${FileDataFragmentDoc}`;
export const TourDataPaymentFragmentDoc = gql`
    fragment TourDataPayment on Tour {
  id
  price
}
    `;
export const LoginDocument = gql`
    mutation login($data: LoginInput!) {
  login(data: $data) {
    accessToken
    refreshToken
    user {
      id
      firstname
      lastname
      email
      role {
        name
        permissions {
          ability
          resource
        }
      }
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation refreshToken($token: String!) {
  refreshToken(token: $token) {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  forgotPassword(email: $email)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation updatePassword($data: UpdatePasswordInput!) {
  updatePassword(data: $data)
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const PasswordTokenValidDocument = gql`
    mutation passwordTokenValid($token: String!, $type: PasswordTokenType!) {
  passwordTokenValid(token: $token, type: $type)
}
    `;
export type PasswordTokenValidMutationFn = Apollo.MutationFunction<PasswordTokenValidMutation, PasswordTokenValidMutationVariables>;

/**
 * __usePasswordTokenValidMutation__
 *
 * To run a mutation, you first call `usePasswordTokenValidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasswordTokenValidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passwordTokenValidMutation, { data, loading, error }] = usePasswordTokenValidMutation({
 *   variables: {
 *      token: // value for 'token'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePasswordTokenValidMutation(baseOptions?: Apollo.MutationHookOptions<PasswordTokenValidMutation, PasswordTokenValidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasswordTokenValidMutation, PasswordTokenValidMutationVariables>(PasswordTokenValidDocument, options);
      }
export type PasswordTokenValidMutationHookResult = ReturnType<typeof usePasswordTokenValidMutation>;
export type PasswordTokenValidMutationResult = Apollo.MutationResult<PasswordTokenValidMutation>;
export type PasswordTokenValidMutationOptions = Apollo.BaseMutationOptions<PasswordTokenValidMutation, PasswordTokenValidMutationVariables>;
export const BookingDocument = gql`
    query Booking($code: String!) {
  booking(code: $code) {
    ...BookingsMinimal
  }
}
    ${BookingsMinimalFragmentDoc}`;

/**
 * __useBookingQuery__
 *
 * To run a query within a React component, call `useBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useBookingQuery(baseOptions: Apollo.QueryHookOptions<BookingQuery, BookingQueryVariables> & ({ variables: BookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
      }
export function useBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export function useBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingQuery, BookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingQuery, BookingQueryVariables>(BookingDocument, options);
        }
export type BookingQueryHookResult = ReturnType<typeof useBookingQuery>;
export type BookingLazyQueryHookResult = ReturnType<typeof useBookingLazyQuery>;
export type BookingSuspenseQueryHookResult = ReturnType<typeof useBookingSuspenseQuery>;
export type BookingQueryResult = Apollo.QueryResult<BookingQuery, BookingQueryVariables>;
export const BookingsPaginatedDocument = gql`
    query bookingsPaginated($data: PaginationInput!, $tourId: String) {
  bookingsPaginated(data: $data, tourId: $tourId) {
    nodes {
      tour {
        title
      }
      ...BookingsMinimal
    }
    pageInfo {
      currentPage
      totalPages
      perPage
    }
    totalCount
  }
}
    ${BookingsMinimalFragmentDoc}`;

/**
 * __useBookingsPaginatedQuery__
 *
 * To run a query within a React component, call `useBookingsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsPaginatedQuery({
 *   variables: {
 *      data: // value for 'data'
 *      tourId: // value for 'tourId'
 *   },
 * });
 */
export function useBookingsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<BookingsPaginatedQuery, BookingsPaginatedQueryVariables> & ({ variables: BookingsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingsPaginatedQuery, BookingsPaginatedQueryVariables>(BookingsPaginatedDocument, options);
      }
export function useBookingsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingsPaginatedQuery, BookingsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingsPaginatedQuery, BookingsPaginatedQueryVariables>(BookingsPaginatedDocument, options);
        }
export function useBookingsPaginatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingsPaginatedQuery, BookingsPaginatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingsPaginatedQuery, BookingsPaginatedQueryVariables>(BookingsPaginatedDocument, options);
        }
export type BookingsPaginatedQueryHookResult = ReturnType<typeof useBookingsPaginatedQuery>;
export type BookingsPaginatedLazyQueryHookResult = ReturnType<typeof useBookingsPaginatedLazyQuery>;
export type BookingsPaginatedSuspenseQueryHookResult = ReturnType<typeof useBookingsPaginatedSuspenseQuery>;
export type BookingsPaginatedQueryResult = Apollo.QueryResult<BookingsPaginatedQuery, BookingsPaginatedQueryVariables>;
export const BookingsCountDocument = gql`
    query bookingsCount($data: BookingCountInput) {
  bookingsCount(data: $data) {
    id
    count
    percentage
    texts
  }
}
    `;

/**
 * __useBookingsCountQuery__
 *
 * To run a query within a React component, call `useBookingsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingsCountQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBookingsCountQuery(baseOptions?: Apollo.QueryHookOptions<BookingsCountQuery, BookingsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingsCountQuery, BookingsCountQueryVariables>(BookingsCountDocument, options);
      }
export function useBookingsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingsCountQuery, BookingsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingsCountQuery, BookingsCountQueryVariables>(BookingsCountDocument, options);
        }
export function useBookingsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookingsCountQuery, BookingsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookingsCountQuery, BookingsCountQueryVariables>(BookingsCountDocument, options);
        }
export type BookingsCountQueryHookResult = ReturnType<typeof useBookingsCountQuery>;
export type BookingsCountLazyQueryHookResult = ReturnType<typeof useBookingsCountLazyQuery>;
export type BookingsCountSuspenseQueryHookResult = ReturnType<typeof useBookingsCountSuspenseQuery>;
export type BookingsCountQueryResult = Apollo.QueryResult<BookingsCountQuery, BookingsCountQueryVariables>;
export const CreateBookingsDocument = gql`
    mutation createBookings($tourId: String!, $bookingCount: Int!, $usages: Int!) {
  createBookings(tourId: $tourId, bookingCount: $bookingCount, usages: $usages) {
    bookings {
      code
    }
    url
  }
}
    `;
export type CreateBookingsMutationFn = Apollo.MutationFunction<CreateBookingsMutation, CreateBookingsMutationVariables>;

/**
 * __useCreateBookingsMutation__
 *
 * To run a mutation, you first call `useCreateBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBookingsMutation, { data, loading, error }] = useCreateBookingsMutation({
 *   variables: {
 *      tourId: // value for 'tourId'
 *      bookingCount: // value for 'bookingCount'
 *      usages: // value for 'usages'
 *   },
 * });
 */
export function useCreateBookingsMutation(baseOptions?: Apollo.MutationHookOptions<CreateBookingsMutation, CreateBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBookingsMutation, CreateBookingsMutationVariables>(CreateBookingsDocument, options);
      }
export type CreateBookingsMutationHookResult = ReturnType<typeof useCreateBookingsMutation>;
export type CreateBookingsMutationResult = Apollo.MutationResult<CreateBookingsMutation>;
export type CreateBookingsMutationOptions = Apollo.BaseMutationOptions<CreateBookingsMutation, CreateBookingsMutationVariables>;
export const ContentDocument = gql`
    query content($id: String!) {
  content(id: $id) {
    ...ContentData
  }
}
    ${ContentDataFragmentDoc}`;

/**
 * __useContentQuery__
 *
 * To run a query within a React component, call `useContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContentQuery(baseOptions: Apollo.QueryHookOptions<ContentQuery, ContentQueryVariables> & ({ variables: ContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
      }
export function useContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export function useContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export type ContentQueryHookResult = ReturnType<typeof useContentQuery>;
export type ContentLazyQueryHookResult = ReturnType<typeof useContentLazyQuery>;
export type ContentSuspenseQueryHookResult = ReturnType<typeof useContentSuspenseQuery>;
export type ContentQueryResult = Apollo.QueryResult<ContentQuery, ContentQueryVariables>;
export const UpdateContentDocument = gql`
    mutation updateContent($id: String!, $data: UpdateContentInput!) {
  updateContent(id: $id, data: $data) {
    ...ContentData
  }
}
    ${ContentDataFragmentDoc}`;
export type UpdateContentMutationFn = Apollo.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(UpdateContentDocument, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;
export const CreateContentDocument = gql`
    mutation createContent($data: CreateContentInput!) {
  createContent(data: $data) {
    ...ContentData
  }
}
    ${ContentDataFragmentDoc}`;
export type CreateContentMutationFn = Apollo.MutationFunction<CreateContentMutation, CreateContentMutationVariables>;

/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentMutation, CreateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentMutation, CreateContentMutationVariables>(CreateContentDocument, options);
      }
export type CreateContentMutationHookResult = ReturnType<typeof useCreateContentMutation>;
export type CreateContentMutationResult = Apollo.MutationResult<CreateContentMutation>;
export type CreateContentMutationOptions = Apollo.BaseMutationOptions<CreateContentMutation, CreateContentMutationVariables>;
export const CloneContentByIdDocument = gql`
    mutation cloneContentById($data: CloneContentByIdInput!) {
  cloneContentById(data: $data) {
    ...ContentData
  }
}
    ${ContentDataFragmentDoc}`;
export type CloneContentByIdMutationFn = Apollo.MutationFunction<CloneContentByIdMutation, CloneContentByIdMutationVariables>;

/**
 * __useCloneContentByIdMutation__
 *
 * To run a mutation, you first call `useCloneContentByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneContentByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneContentByIdMutation, { data, loading, error }] = useCloneContentByIdMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCloneContentByIdMutation(baseOptions?: Apollo.MutationHookOptions<CloneContentByIdMutation, CloneContentByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneContentByIdMutation, CloneContentByIdMutationVariables>(CloneContentByIdDocument, options);
      }
export type CloneContentByIdMutationHookResult = ReturnType<typeof useCloneContentByIdMutation>;
export type CloneContentByIdMutationResult = Apollo.MutationResult<CloneContentByIdMutation>;
export type CloneContentByIdMutationOptions = Apollo.BaseMutationOptions<CloneContentByIdMutation, CloneContentByIdMutationVariables>;
export const CloneContentDocument = gql`
    mutation cloneContent($id: String!) {
  cloneContent(contentId: $id) {
    ...ContentData
  }
}
    ${ContentDataFragmentDoc}`;
export type CloneContentMutationFn = Apollo.MutationFunction<CloneContentMutation, CloneContentMutationVariables>;

/**
 * __useCloneContentMutation__
 *
 * To run a mutation, you first call `useCloneContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneContentMutation, { data, loading, error }] = useCloneContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneContentMutation(baseOptions?: Apollo.MutationHookOptions<CloneContentMutation, CloneContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneContentMutation, CloneContentMutationVariables>(CloneContentDocument, options);
      }
export type CloneContentMutationHookResult = ReturnType<typeof useCloneContentMutation>;
export type CloneContentMutationResult = Apollo.MutationResult<CloneContentMutation>;
export type CloneContentMutationOptions = Apollo.BaseMutationOptions<CloneContentMutation, CloneContentMutationVariables>;
export const DeleteContentDocument = gql`
    mutation deleteContent($id: String!) {
  deleteContent(id: $id)
}
    `;
export type DeleteContentMutationFn = Apollo.MutationFunction<DeleteContentMutation, DeleteContentMutationVariables>;

/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentMutation, DeleteContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentMutation, DeleteContentMutationVariables>(DeleteContentDocument, options);
      }
export type DeleteContentMutationHookResult = ReturnType<typeof useDeleteContentMutation>;
export type DeleteContentMutationResult = Apollo.MutationResult<DeleteContentMutation>;
export type DeleteContentMutationOptions = Apollo.BaseMutationOptions<DeleteContentMutation, DeleteContentMutationVariables>;
export const ReorderContentDocument = gql`
    mutation reorderContent($ids: [String!]!) {
  reorderContents(contentIds: $ids) {
    ...ContentData
  }
}
    ${ContentDataFragmentDoc}`;
export type ReorderContentMutationFn = Apollo.MutationFunction<ReorderContentMutation, ReorderContentMutationVariables>;

/**
 * __useReorderContentMutation__
 *
 * To run a mutation, you first call `useReorderContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderContentMutation, { data, loading, error }] = useReorderContentMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useReorderContentMutation(baseOptions?: Apollo.MutationHookOptions<ReorderContentMutation, ReorderContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderContentMutation, ReorderContentMutationVariables>(ReorderContentDocument, options);
      }
export type ReorderContentMutationHookResult = ReturnType<typeof useReorderContentMutation>;
export type ReorderContentMutationResult = Apollo.MutationResult<ReorderContentMutation>;
export type ReorderContentMutationOptions = Apollo.BaseMutationOptions<ReorderContentMutation, ReorderContentMutationVariables>;
export const CustomerGroupsDocument = gql`
    query customerGroups {
  customerGroups {
    ...CustomerGroupData
  }
}
    ${CustomerGroupDataFragmentDoc}`;

/**
 * __useCustomerGroupsQuery__
 *
 * To run a query within a React component, call `useCustomerGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CustomerGroupsQuery, CustomerGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerGroupsQuery, CustomerGroupsQueryVariables>(CustomerGroupsDocument, options);
      }
export function useCustomerGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerGroupsQuery, CustomerGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerGroupsQuery, CustomerGroupsQueryVariables>(CustomerGroupsDocument, options);
        }
export function useCustomerGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerGroupsQuery, CustomerGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerGroupsQuery, CustomerGroupsQueryVariables>(CustomerGroupsDocument, options);
        }
export type CustomerGroupsQueryHookResult = ReturnType<typeof useCustomerGroupsQuery>;
export type CustomerGroupsLazyQueryHookResult = ReturnType<typeof useCustomerGroupsLazyQuery>;
export type CustomerGroupsSuspenseQueryHookResult = ReturnType<typeof useCustomerGroupsSuspenseQuery>;
export type CustomerGroupsQueryResult = Apollo.QueryResult<CustomerGroupsQuery, CustomerGroupsQueryVariables>;
export const UploadFileDocument = gql`
    mutation uploadFile($data: UploadFileInput!, $file: Upload) {
  uploadFile(data: $data, file: $file) {
    ...FileData
  }
}
    ${FileDataFragmentDoc}`;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      data: // value for 'data'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;
export const ReplaceFileInOrderDocument = gql`
    mutation replaceFileInOrder($data: UploadFileInput!, $file: Upload!) {
  replaceFileInOrder(data: $data, file: $file) {
    ...FileData
  }
}
    ${FileDataFragmentDoc}`;
export type ReplaceFileInOrderMutationFn = Apollo.MutationFunction<ReplaceFileInOrderMutation, ReplaceFileInOrderMutationVariables>;

/**
 * __useReplaceFileInOrderMutation__
 *
 * To run a mutation, you first call `useReplaceFileInOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceFileInOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceFileInOrderMutation, { data, loading, error }] = useReplaceFileInOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useReplaceFileInOrderMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceFileInOrderMutation, ReplaceFileInOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceFileInOrderMutation, ReplaceFileInOrderMutationVariables>(ReplaceFileInOrderDocument, options);
      }
export type ReplaceFileInOrderMutationHookResult = ReturnType<typeof useReplaceFileInOrderMutation>;
export type ReplaceFileInOrderMutationResult = Apollo.MutationResult<ReplaceFileInOrderMutation>;
export type ReplaceFileInOrderMutationOptions = Apollo.BaseMutationOptions<ReplaceFileInOrderMutation, ReplaceFileInOrderMutationVariables>;
export const UpdateFileDocument = gql`
    mutation updateFile($data: UpdateFileInput!, $id: String!) {
  updateFileInfo(data: $data, id: $id) {
    ...FileData
  }
}
    ${FileDataFragmentDoc}`;
export type UpdateFileMutationFn = Apollo.MutationFunction<UpdateFileMutation, UpdateFileMutationVariables>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation, UpdateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation, UpdateFileMutationVariables>(UpdateFileDocument, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult = Apollo.MutationResult<UpdateFileMutation>;
export type UpdateFileMutationOptions = Apollo.BaseMutationOptions<UpdateFileMutation, UpdateFileMutationVariables>;
export const DeleteFileDocument = gql`
    mutation deleteFile($id: String!) {
  deleteFile(id: $id) {
    ...FileData
  }
}
    ${FileDataFragmentDoc}`;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const ContentNuggetDocument = gql`
    query contentNugget($id: String!) {
  contentNugget(id: $id) {
    ...ContentNuggetData
  }
}
    ${ContentNuggetDataFragmentDoc}`;

/**
 * __useContentNuggetQuery__
 *
 * To run a query within a React component, call `useContentNuggetQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentNuggetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentNuggetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContentNuggetQuery(baseOptions: Apollo.QueryHookOptions<ContentNuggetQuery, ContentNuggetQueryVariables> & ({ variables: ContentNuggetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentNuggetQuery, ContentNuggetQueryVariables>(ContentNuggetDocument, options);
      }
export function useContentNuggetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentNuggetQuery, ContentNuggetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentNuggetQuery, ContentNuggetQueryVariables>(ContentNuggetDocument, options);
        }
export function useContentNuggetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentNuggetQuery, ContentNuggetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentNuggetQuery, ContentNuggetQueryVariables>(ContentNuggetDocument, options);
        }
export type ContentNuggetQueryHookResult = ReturnType<typeof useContentNuggetQuery>;
export type ContentNuggetLazyQueryHookResult = ReturnType<typeof useContentNuggetLazyQuery>;
export type ContentNuggetSuspenseQueryHookResult = ReturnType<typeof useContentNuggetSuspenseQuery>;
export type ContentNuggetQueryResult = Apollo.QueryResult<ContentNuggetQuery, ContentNuggetQueryVariables>;
export const UpdateContentNuggetDocument = gql`
    mutation updateContentNugget($id: String!, $data: UpdateContentNuggetInput!) {
  updateContentNugget(id: $id, data: $data) {
    ...ContentNuggetData
  }
}
    ${ContentNuggetDataFragmentDoc}`;
export type UpdateContentNuggetMutationFn = Apollo.MutationFunction<UpdateContentNuggetMutation, UpdateContentNuggetMutationVariables>;

/**
 * __useUpdateContentNuggetMutation__
 *
 * To run a mutation, you first call `useUpdateContentNuggetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentNuggetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentNuggetMutation, { data, loading, error }] = useUpdateContentNuggetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentNuggetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentNuggetMutation, UpdateContentNuggetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentNuggetMutation, UpdateContentNuggetMutationVariables>(UpdateContentNuggetDocument, options);
      }
export type UpdateContentNuggetMutationHookResult = ReturnType<typeof useUpdateContentNuggetMutation>;
export type UpdateContentNuggetMutationResult = Apollo.MutationResult<UpdateContentNuggetMutation>;
export type UpdateContentNuggetMutationOptions = Apollo.BaseMutationOptions<UpdateContentNuggetMutation, UpdateContentNuggetMutationVariables>;
export const CreateContentNuggetDocument = gql`
    mutation createContentNugget($data: CreateContentNuggetInput!) {
  createContentNugget(data: $data) {
    ...ContentNuggetData
  }
}
    ${ContentNuggetDataFragmentDoc}`;
export type CreateContentNuggetMutationFn = Apollo.MutationFunction<CreateContentNuggetMutation, CreateContentNuggetMutationVariables>;

/**
 * __useCreateContentNuggetMutation__
 *
 * To run a mutation, you first call `useCreateContentNuggetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentNuggetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentNuggetMutation, { data, loading, error }] = useCreateContentNuggetMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentNuggetMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentNuggetMutation, CreateContentNuggetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentNuggetMutation, CreateContentNuggetMutationVariables>(CreateContentNuggetDocument, options);
      }
export type CreateContentNuggetMutationHookResult = ReturnType<typeof useCreateContentNuggetMutation>;
export type CreateContentNuggetMutationResult = Apollo.MutationResult<CreateContentNuggetMutation>;
export type CreateContentNuggetMutationOptions = Apollo.BaseMutationOptions<CreateContentNuggetMutation, CreateContentNuggetMutationVariables>;
export const CloneContentNuggetDocument = gql`
    mutation cloneContentNugget($id: String!, $targetSectionId: String) {
  cloneContentNugget(nuggetId: $id, targetSectionId: $targetSectionId) {
    ...ContentNuggetData
  }
}
    ${ContentNuggetDataFragmentDoc}`;
export type CloneContentNuggetMutationFn = Apollo.MutationFunction<CloneContentNuggetMutation, CloneContentNuggetMutationVariables>;

/**
 * __useCloneContentNuggetMutation__
 *
 * To run a mutation, you first call `useCloneContentNuggetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneContentNuggetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneContentNuggetMutation, { data, loading, error }] = useCloneContentNuggetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      targetSectionId: // value for 'targetSectionId'
 *   },
 * });
 */
export function useCloneContentNuggetMutation(baseOptions?: Apollo.MutationHookOptions<CloneContentNuggetMutation, CloneContentNuggetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneContentNuggetMutation, CloneContentNuggetMutationVariables>(CloneContentNuggetDocument, options);
      }
export type CloneContentNuggetMutationHookResult = ReturnType<typeof useCloneContentNuggetMutation>;
export type CloneContentNuggetMutationResult = Apollo.MutationResult<CloneContentNuggetMutation>;
export type CloneContentNuggetMutationOptions = Apollo.BaseMutationOptions<CloneContentNuggetMutation, CloneContentNuggetMutationVariables>;
export const ReorderContentNuggetsDocument = gql`
    mutation reorderContentNuggets($nuggetIds: [String!]!) {
  reorderContentNuggets(nuggetIds: $nuggetIds) {
    id
    order
  }
}
    `;
export type ReorderContentNuggetsMutationFn = Apollo.MutationFunction<ReorderContentNuggetsMutation, ReorderContentNuggetsMutationVariables>;

/**
 * __useReorderContentNuggetsMutation__
 *
 * To run a mutation, you first call `useReorderContentNuggetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderContentNuggetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderContentNuggetsMutation, { data, loading, error }] = useReorderContentNuggetsMutation({
 *   variables: {
 *      nuggetIds: // value for 'nuggetIds'
 *   },
 * });
 */
export function useReorderContentNuggetsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderContentNuggetsMutation, ReorderContentNuggetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderContentNuggetsMutation, ReorderContentNuggetsMutationVariables>(ReorderContentNuggetsDocument, options);
      }
export type ReorderContentNuggetsMutationHookResult = ReturnType<typeof useReorderContentNuggetsMutation>;
export type ReorderContentNuggetsMutationResult = Apollo.MutationResult<ReorderContentNuggetsMutation>;
export type ReorderContentNuggetsMutationOptions = Apollo.BaseMutationOptions<ReorderContentNuggetsMutation, ReorderContentNuggetsMutationVariables>;
export const DeleteContentNuggetDocument = gql`
    mutation deleteContentNugget($id: String!) {
  deleteContentNugget(id: $id)
}
    `;
export type DeleteContentNuggetMutationFn = Apollo.MutationFunction<DeleteContentNuggetMutation, DeleteContentNuggetMutationVariables>;

/**
 * __useDeleteContentNuggetMutation__
 *
 * To run a mutation, you first call `useDeleteContentNuggetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentNuggetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentNuggetMutation, { data, loading, error }] = useDeleteContentNuggetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContentNuggetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentNuggetMutation, DeleteContentNuggetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentNuggetMutation, DeleteContentNuggetMutationVariables>(DeleteContentNuggetDocument, options);
      }
export type DeleteContentNuggetMutationHookResult = ReturnType<typeof useDeleteContentNuggetMutation>;
export type DeleteContentNuggetMutationResult = Apollo.MutationResult<DeleteContentNuggetMutation>;
export type DeleteContentNuggetMutationOptions = Apollo.BaseMutationOptions<DeleteContentNuggetMutation, DeleteContentNuggetMutationVariables>;
export const PaymentMethodsDocument = gql`
    query paymentMethods {
  paymentMethods
}
    `;

/**
 * __usePaymentMethodsQuery__
 *
 * To run a query within a React component, call `usePaymentMethodsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodsQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
      }
export function usePaymentMethodsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export function usePaymentMethodsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodsQuery, PaymentMethodsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentMethodsQuery, PaymentMethodsQueryVariables>(PaymentMethodsDocument, options);
        }
export type PaymentMethodsQueryHookResult = ReturnType<typeof usePaymentMethodsQuery>;
export type PaymentMethodsLazyQueryHookResult = ReturnType<typeof usePaymentMethodsLazyQuery>;
export type PaymentMethodsSuspenseQueryHookResult = ReturnType<typeof usePaymentMethodsSuspenseQuery>;
export type PaymentMethodsQueryResult = Apollo.QueryResult<PaymentMethodsQuery, PaymentMethodsQueryVariables>;
export const TourPoiDocument = gql`
    query tourPoi($id: String!) {
  tourPoi(id: $id) {
    ...TourPoiFull
  }
}
    ${TourPoiFullFragmentDoc}`;

/**
 * __useTourPoiQuery__
 *
 * To run a query within a React component, call `useTourPoiQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourPoiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourPoiQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTourPoiQuery(baseOptions: Apollo.QueryHookOptions<TourPoiQuery, TourPoiQueryVariables> & ({ variables: TourPoiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourPoiQuery, TourPoiQueryVariables>(TourPoiDocument, options);
      }
export function useTourPoiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourPoiQuery, TourPoiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourPoiQuery, TourPoiQueryVariables>(TourPoiDocument, options);
        }
export function useTourPoiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TourPoiQuery, TourPoiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TourPoiQuery, TourPoiQueryVariables>(TourPoiDocument, options);
        }
export type TourPoiQueryHookResult = ReturnType<typeof useTourPoiQuery>;
export type TourPoiLazyQueryHookResult = ReturnType<typeof useTourPoiLazyQuery>;
export type TourPoiSuspenseQueryHookResult = ReturnType<typeof useTourPoiSuspenseQuery>;
export type TourPoiQueryResult = Apollo.QueryResult<TourPoiQuery, TourPoiQueryVariables>;
export const UpdateTourPoiDocument = gql`
    mutation updateTourPoi($id: String!, $data: UpdateTourPoiInput!) {
  updateTourPoi(id: $id, data: $data) {
    ...TourPoiFull
  }
}
    ${TourPoiFullFragmentDoc}`;
export type UpdateTourPoiMutationFn = Apollo.MutationFunction<UpdateTourPoiMutation, UpdateTourPoiMutationVariables>;

/**
 * __useUpdateTourPoiMutation__
 *
 * To run a mutation, you first call `useUpdateTourPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourPoiMutation, { data, loading, error }] = useUpdateTourPoiMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTourPoiMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTourPoiMutation, UpdateTourPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTourPoiMutation, UpdateTourPoiMutationVariables>(UpdateTourPoiDocument, options);
      }
export type UpdateTourPoiMutationHookResult = ReturnType<typeof useUpdateTourPoiMutation>;
export type UpdateTourPoiMutationResult = Apollo.MutationResult<UpdateTourPoiMutation>;
export type UpdateTourPoiMutationOptions = Apollo.BaseMutationOptions<UpdateTourPoiMutation, UpdateTourPoiMutationVariables>;
export const CreateTourPoiDocument = gql`
    mutation createTourPoi($data: CreateTourPoiInput!) {
  createTourPoi(data: $data) {
    ...TourPoiFull
  }
}
    ${TourPoiFullFragmentDoc}`;
export type CreateTourPoiMutationFn = Apollo.MutationFunction<CreateTourPoiMutation, CreateTourPoiMutationVariables>;

/**
 * __useCreateTourPoiMutation__
 *
 * To run a mutation, you first call `useCreateTourPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourPoiMutation, { data, loading, error }] = useCreateTourPoiMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTourPoiMutation(baseOptions?: Apollo.MutationHookOptions<CreateTourPoiMutation, CreateTourPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTourPoiMutation, CreateTourPoiMutationVariables>(CreateTourPoiDocument, options);
      }
export type CreateTourPoiMutationHookResult = ReturnType<typeof useCreateTourPoiMutation>;
export type CreateTourPoiMutationResult = Apollo.MutationResult<CreateTourPoiMutation>;
export type CreateTourPoiMutationOptions = Apollo.BaseMutationOptions<CreateTourPoiMutation, CreateTourPoiMutationVariables>;
export const CloneTourPoiDocument = gql`
    mutation cloneTourPoi($poiId: String!, $tourModeId: String!) {
  cloneTourPoi(poiId: $poiId, tourModeId: $tourModeId) {
    ...TourPoiFull
  }
}
    ${TourPoiFullFragmentDoc}`;
export type CloneTourPoiMutationFn = Apollo.MutationFunction<CloneTourPoiMutation, CloneTourPoiMutationVariables>;

/**
 * __useCloneTourPoiMutation__
 *
 * To run a mutation, you first call `useCloneTourPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTourPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTourPoiMutation, { data, loading, error }] = useCloneTourPoiMutation({
 *   variables: {
 *      poiId: // value for 'poiId'
 *      tourModeId: // value for 'tourModeId'
 *   },
 * });
 */
export function useCloneTourPoiMutation(baseOptions?: Apollo.MutationHookOptions<CloneTourPoiMutation, CloneTourPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneTourPoiMutation, CloneTourPoiMutationVariables>(CloneTourPoiDocument, options);
      }
export type CloneTourPoiMutationHookResult = ReturnType<typeof useCloneTourPoiMutation>;
export type CloneTourPoiMutationResult = Apollo.MutationResult<CloneTourPoiMutation>;
export type CloneTourPoiMutationOptions = Apollo.BaseMutationOptions<CloneTourPoiMutation, CloneTourPoiMutationVariables>;
export const DeleteTourPoiDocument = gql`
    mutation deleteTourPoi($id: String!) {
  deleteTourPoi(id: $id)
}
    `;
export type DeleteTourPoiMutationFn = Apollo.MutationFunction<DeleteTourPoiMutation, DeleteTourPoiMutationVariables>;

/**
 * __useDeleteTourPoiMutation__
 *
 * To run a mutation, you first call `useDeleteTourPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTourPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTourPoiMutation, { data, loading, error }] = useDeleteTourPoiMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTourPoiMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTourPoiMutation, DeleteTourPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTourPoiMutation, DeleteTourPoiMutationVariables>(DeleteTourPoiDocument, options);
      }
export type DeleteTourPoiMutationHookResult = ReturnType<typeof useDeleteTourPoiMutation>;
export type DeleteTourPoiMutationResult = Apollo.MutationResult<DeleteTourPoiMutation>;
export type DeleteTourPoiMutationOptions = Apollo.BaseMutationOptions<DeleteTourPoiMutation, DeleteTourPoiMutationVariables>;
export const DisconnectTourPoiDocument = gql`
    mutation disconnectTourPoi($id: String!, $modeId: String!) {
  disconnectTourPoi(id: $id, modeId: $modeId)
}
    `;
export type DisconnectTourPoiMutationFn = Apollo.MutationFunction<DisconnectTourPoiMutation, DisconnectTourPoiMutationVariables>;

/**
 * __useDisconnectTourPoiMutation__
 *
 * To run a mutation, you first call `useDisconnectTourPoiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectTourPoiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectTourPoiMutation, { data, loading, error }] = useDisconnectTourPoiMutation({
 *   variables: {
 *      id: // value for 'id'
 *      modeId: // value for 'modeId'
 *   },
 * });
 */
export function useDisconnectTourPoiMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectTourPoiMutation, DisconnectTourPoiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectTourPoiMutation, DisconnectTourPoiMutationVariables>(DisconnectTourPoiDocument, options);
      }
export type DisconnectTourPoiMutationHookResult = ReturnType<typeof useDisconnectTourPoiMutation>;
export type DisconnectTourPoiMutationResult = Apollo.MutationResult<DisconnectTourPoiMutation>;
export type DisconnectTourPoiMutationOptions = Apollo.BaseMutationOptions<DisconnectTourPoiMutation, DisconnectTourPoiMutationVariables>;
export const ReorderTourPoisDocument = gql`
    mutation reorderTourPois($poiIds: [String!]!, $tourModeId: String!) {
  reorderTourPois(poiIds: $poiIds, tourModeId: $tourModeId) {
    id
  }
}
    `;
export type ReorderTourPoisMutationFn = Apollo.MutationFunction<ReorderTourPoisMutation, ReorderTourPoisMutationVariables>;

/**
 * __useReorderTourPoisMutation__
 *
 * To run a mutation, you first call `useReorderTourPoisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderTourPoisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderTourPoisMutation, { data, loading, error }] = useReorderTourPoisMutation({
 *   variables: {
 *      poiIds: // value for 'poiIds'
 *      tourModeId: // value for 'tourModeId'
 *   },
 * });
 */
export function useReorderTourPoisMutation(baseOptions?: Apollo.MutationHookOptions<ReorderTourPoisMutation, ReorderTourPoisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderTourPoisMutation, ReorderTourPoisMutationVariables>(ReorderTourPoisDocument, options);
      }
export type ReorderTourPoisMutationHookResult = ReturnType<typeof useReorderTourPoisMutation>;
export type ReorderTourPoisMutationResult = Apollo.MutationResult<ReorderTourPoisMutation>;
export type ReorderTourPoisMutationOptions = Apollo.BaseMutationOptions<ReorderTourPoisMutation, ReorderTourPoisMutationVariables>;
export const SearchTourContentDocument = gql`
    query searchTourContent($tourId: String!, $query: String!) {
  searchTourContent(tourId: $tourId, query: $query) {
    id
    kind
    modeId
    poiId
    sectionId
    nuggetId
    contentId
    contentType
    matchedKey
    snippet
    breadcrumb
  }
}
    `;

/**
 * __useSearchTourContentQuery__
 *
 * To run a query within a React component, call `useSearchTourContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTourContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTourContentQuery({
 *   variables: {
 *      tourId: // value for 'tourId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchTourContentQuery(baseOptions: Apollo.QueryHookOptions<SearchTourContentQuery, SearchTourContentQueryVariables> & ({ variables: SearchTourContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTourContentQuery, SearchTourContentQueryVariables>(SearchTourContentDocument, options);
      }
export function useSearchTourContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTourContentQuery, SearchTourContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTourContentQuery, SearchTourContentQueryVariables>(SearchTourContentDocument, options);
        }
export function useSearchTourContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchTourContentQuery, SearchTourContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchTourContentQuery, SearchTourContentQueryVariables>(SearchTourContentDocument, options);
        }
export type SearchTourContentQueryHookResult = ReturnType<typeof useSearchTourContentQuery>;
export type SearchTourContentLazyQueryHookResult = ReturnType<typeof useSearchTourContentLazyQuery>;
export type SearchTourContentSuspenseQueryHookResult = ReturnType<typeof useSearchTourContentSuspenseQuery>;
export type SearchTourContentQueryResult = Apollo.QueryResult<SearchTourContentQuery, SearchTourContentQueryVariables>;
export const UpdateContentSectionDocument = gql`
    mutation updateContentSection($id: String!, $data: UpdateContentSectionInput!) {
  updateContentSection(id: $id, data: $data) {
    ...ContentSectionFull
  }
}
    ${ContentSectionFullFragmentDoc}`;
export type UpdateContentSectionMutationFn = Apollo.MutationFunction<UpdateContentSectionMutation, UpdateContentSectionMutationVariables>;

/**
 * __useUpdateContentSectionMutation__
 *
 * To run a mutation, you first call `useUpdateContentSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentSectionMutation, { data, loading, error }] = useUpdateContentSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContentSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentSectionMutation, UpdateContentSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentSectionMutation, UpdateContentSectionMutationVariables>(UpdateContentSectionDocument, options);
      }
export type UpdateContentSectionMutationHookResult = ReturnType<typeof useUpdateContentSectionMutation>;
export type UpdateContentSectionMutationResult = Apollo.MutationResult<UpdateContentSectionMutation>;
export type UpdateContentSectionMutationOptions = Apollo.BaseMutationOptions<UpdateContentSectionMutation, UpdateContentSectionMutationVariables>;
export const CreateContentSectionDocument = gql`
    mutation createContentSection($data: CreateContentSectionInput!) {
  createContentSection(data: $data) {
    ...ContentSectionFull
  }
}
    ${ContentSectionFullFragmentDoc}`;
export type CreateContentSectionMutationFn = Apollo.MutationFunction<CreateContentSectionMutation, CreateContentSectionMutationVariables>;

/**
 * __useCreateContentSectionMutation__
 *
 * To run a mutation, you first call `useCreateContentSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentSectionMutation, { data, loading, error }] = useCreateContentSectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentSectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentSectionMutation, CreateContentSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentSectionMutation, CreateContentSectionMutationVariables>(CreateContentSectionDocument, options);
      }
export type CreateContentSectionMutationHookResult = ReturnType<typeof useCreateContentSectionMutation>;
export type CreateContentSectionMutationResult = Apollo.MutationResult<CreateContentSectionMutation>;
export type CreateContentSectionMutationOptions = Apollo.BaseMutationOptions<CreateContentSectionMutation, CreateContentSectionMutationVariables>;
export const CloneContentSectionDocument = gql`
    mutation cloneContentSection($id: String!, $targetPoiId: String) {
  cloneContentSection(sectionId: $id, targetPoiId: $targetPoiId) {
    ...ContentSectionFull
  }
}
    ${ContentSectionFullFragmentDoc}`;
export type CloneContentSectionMutationFn = Apollo.MutationFunction<CloneContentSectionMutation, CloneContentSectionMutationVariables>;

/**
 * __useCloneContentSectionMutation__
 *
 * To run a mutation, you first call `useCloneContentSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneContentSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneContentSectionMutation, { data, loading, error }] = useCloneContentSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      targetPoiId: // value for 'targetPoiId'
 *   },
 * });
 */
export function useCloneContentSectionMutation(baseOptions?: Apollo.MutationHookOptions<CloneContentSectionMutation, CloneContentSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneContentSectionMutation, CloneContentSectionMutationVariables>(CloneContentSectionDocument, options);
      }
export type CloneContentSectionMutationHookResult = ReturnType<typeof useCloneContentSectionMutation>;
export type CloneContentSectionMutationResult = Apollo.MutationResult<CloneContentSectionMutation>;
export type CloneContentSectionMutationOptions = Apollo.BaseMutationOptions<CloneContentSectionMutation, CloneContentSectionMutationVariables>;
export const ReorderContentSectionsDocument = gql`
    mutation reorderContentSections($sectionIds: [String!]!) {
  reorderContentSections(sectionIds: $sectionIds) {
    id
    order
  }
}
    `;
export type ReorderContentSectionsMutationFn = Apollo.MutationFunction<ReorderContentSectionsMutation, ReorderContentSectionsMutationVariables>;

/**
 * __useReorderContentSectionsMutation__
 *
 * To run a mutation, you first call `useReorderContentSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderContentSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderContentSectionsMutation, { data, loading, error }] = useReorderContentSectionsMutation({
 *   variables: {
 *      sectionIds: // value for 'sectionIds'
 *   },
 * });
 */
export function useReorderContentSectionsMutation(baseOptions?: Apollo.MutationHookOptions<ReorderContentSectionsMutation, ReorderContentSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderContentSectionsMutation, ReorderContentSectionsMutationVariables>(ReorderContentSectionsDocument, options);
      }
export type ReorderContentSectionsMutationHookResult = ReturnType<typeof useReorderContentSectionsMutation>;
export type ReorderContentSectionsMutationResult = Apollo.MutationResult<ReorderContentSectionsMutation>;
export type ReorderContentSectionsMutationOptions = Apollo.BaseMutationOptions<ReorderContentSectionsMutation, ReorderContentSectionsMutationVariables>;
export const DeleteContentSectionDocument = gql`
    mutation deleteContentSection($id: String!) {
  deleteContentSection(id: $id)
}
    `;
export type DeleteContentSectionMutationFn = Apollo.MutationFunction<DeleteContentSectionMutation, DeleteContentSectionMutationVariables>;

/**
 * __useDeleteContentSectionMutation__
 *
 * To run a mutation, you first call `useDeleteContentSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentSectionMutation, { data, loading, error }] = useDeleteContentSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContentSectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentSectionMutation, DeleteContentSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentSectionMutation, DeleteContentSectionMutationVariables>(DeleteContentSectionDocument, options);
      }
export type DeleteContentSectionMutationHookResult = ReturnType<typeof useDeleteContentSectionMutation>;
export type DeleteContentSectionMutationResult = Apollo.MutationResult<DeleteContentSectionMutation>;
export type DeleteContentSectionMutationOptions = Apollo.BaseMutationOptions<DeleteContentSectionMutation, DeleteContentSectionMutationVariables>;
export const TagDocument = gql`
    query tag($id: String!) {
  tag(id: $id) {
    ...PoiTagData
  }
}
    ${PoiTagDataFragmentDoc}`;

/**
 * __useTagQuery__
 *
 * To run a query within a React component, call `useTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagQuery(baseOptions: Apollo.QueryHookOptions<TagQuery, TagQueryVariables> & ({ variables: TagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagQuery, TagQueryVariables>(TagDocument, options);
      }
export function useTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export function useTagSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagQuery, TagQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagQuery, TagQueryVariables>(TagDocument, options);
        }
export type TagQueryHookResult = ReturnType<typeof useTagQuery>;
export type TagLazyQueryHookResult = ReturnType<typeof useTagLazyQuery>;
export type TagSuspenseQueryHookResult = ReturnType<typeof useTagSuspenseQuery>;
export type TagQueryResult = Apollo.QueryResult<TagQuery, TagQueryVariables>;
export const TagsDocument = gql`
    query tags($key: String, $category: String) {
  tags(key: $key, category: $category) {
    ...PoiTagData
  }
}
    ${PoiTagDataFragmentDoc}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *      key: // value for 'key'
 *      category: // value for 'category'
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export function useTagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsSuspenseQueryHookResult = ReturnType<typeof useTagsSuspenseQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const CreateTagDocument = gql`
    mutation createTag($data: CreateTagInput!) {
  createTag(data: $data) {
    ...PoiTagData
  }
}
    ${PoiTagDataFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation updateTag($id: String!, $data: UpdateTagInput!) {
  updatePoiTag(id: $id, data: $data) {
    ...PoiTagData
  }
}
    ${PoiTagDataFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const CreateTagRelationsDocument = gql`
    mutation createTagRelations($tagIds: [String!]!, $model: String!, $modelId: String!) {
  createTagRelations(tagIds: $tagIds, model: $model, modelId: $modelId)
}
    `;
export type CreateTagRelationsMutationFn = Apollo.MutationFunction<CreateTagRelationsMutation, CreateTagRelationsMutationVariables>;

/**
 * __useCreateTagRelationsMutation__
 *
 * To run a mutation, you first call `useCreateTagRelationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagRelationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagRelationsMutation, { data, loading, error }] = useCreateTagRelationsMutation({
 *   variables: {
 *      tagIds: // value for 'tagIds'
 *      model: // value for 'model'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useCreateTagRelationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagRelationsMutation, CreateTagRelationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagRelationsMutation, CreateTagRelationsMutationVariables>(CreateTagRelationsDocument, options);
      }
export type CreateTagRelationsMutationHookResult = ReturnType<typeof useCreateTagRelationsMutation>;
export type CreateTagRelationsMutationResult = Apollo.MutationResult<CreateTagRelationsMutation>;
export type CreateTagRelationsMutationOptions = Apollo.BaseMutationOptions<CreateTagRelationsMutation, CreateTagRelationsMutationVariables>;
export const DisconnectTagsDocument = gql`
    mutation disconnectTags($tagIds: [String!]!, $model: String!, $modelId: String!) {
  disconnectTags(tagIds: $tagIds, model: $model, modelId: $modelId)
}
    `;
export type DisconnectTagsMutationFn = Apollo.MutationFunction<DisconnectTagsMutation, DisconnectTagsMutationVariables>;

/**
 * __useDisconnectTagsMutation__
 *
 * To run a mutation, you first call `useDisconnectTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectTagsMutation, { data, loading, error }] = useDisconnectTagsMutation({
 *   variables: {
 *      tagIds: // value for 'tagIds'
 *      model: // value for 'model'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDisconnectTagsMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectTagsMutation, DisconnectTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectTagsMutation, DisconnectTagsMutationVariables>(DisconnectTagsDocument, options);
      }
export type DisconnectTagsMutationHookResult = ReturnType<typeof useDisconnectTagsMutation>;
export type DisconnectTagsMutationResult = Apollo.MutationResult<DisconnectTagsMutation>;
export type DisconnectTagsMutationOptions = Apollo.BaseMutationOptions<DisconnectTagsMutation, DisconnectTagsMutationVariables>;
export const DeleteTranslationDocument = gql`
    mutation deleteTranslation($key: String!, $model: String!, $modelId: String!) {
  deleteTranslation(key: $key, model: $model, modelId: $modelId) {
    id
  }
}
    `;
export type DeleteTranslationMutationFn = Apollo.MutationFunction<DeleteTranslationMutation, DeleteTranslationMutationVariables>;

/**
 * __useDeleteTranslationMutation__
 *
 * To run a mutation, you first call `useDeleteTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTranslationMutation, { data, loading, error }] = useDeleteTranslationMutation({
 *   variables: {
 *      key: // value for 'key'
 *      model: // value for 'model'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDeleteTranslationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTranslationMutation, DeleteTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTranslationMutation, DeleteTranslationMutationVariables>(DeleteTranslationDocument, options);
      }
export type DeleteTranslationMutationHookResult = ReturnType<typeof useDeleteTranslationMutation>;
export type DeleteTranslationMutationResult = Apollo.MutationResult<DeleteTranslationMutation>;
export type DeleteTranslationMutationOptions = Apollo.BaseMutationOptions<DeleteTranslationMutation, DeleteTranslationMutationVariables>;
export const DeleteTranslationsDocument = gql`
    mutation deleteTranslations($keys: [String!]!, $model: String!, $modelId: String!) {
  deleteTranslations(keys: $keys, model: $model, modelId: $modelId) {
    id
  }
}
    `;
export type DeleteTranslationsMutationFn = Apollo.MutationFunction<DeleteTranslationsMutation, DeleteTranslationsMutationVariables>;

/**
 * __useDeleteTranslationsMutation__
 *
 * To run a mutation, you first call `useDeleteTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTranslationsMutation, { data, loading, error }] = useDeleteTranslationsMutation({
 *   variables: {
 *      keys: // value for 'keys'
 *      model: // value for 'model'
 *      modelId: // value for 'modelId'
 *   },
 * });
 */
export function useDeleteTranslationsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTranslationsMutation, DeleteTranslationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTranslationsMutation, DeleteTranslationsMutationVariables>(DeleteTranslationsDocument, options);
      }
export type DeleteTranslationsMutationHookResult = ReturnType<typeof useDeleteTranslationsMutation>;
export type DeleteTranslationsMutationResult = Apollo.MutationResult<DeleteTranslationsMutation>;
export type DeleteTranslationsMutationOptions = Apollo.BaseMutationOptions<DeleteTranslationsMutation, DeleteTranslationsMutationVariables>;
export const ToursDocument = gql`
    query tours {
  tours {
    ...TourDataMinimal
    ratings(limit: 5) {
      ...TourRatingMinimal
    }
  }
}
    ${TourDataMinimalFragmentDoc}
${TourRatingMinimalFragmentDoc}`;

/**
 * __useToursQuery__
 *
 * To run a query within a React component, call `useToursQuery` and pass it any options that fit your needs.
 * When your component renders, `useToursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useToursQuery({
 *   variables: {
 *   },
 * });
 */
export function useToursQuery(baseOptions?: Apollo.QueryHookOptions<ToursQuery, ToursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ToursQuery, ToursQueryVariables>(ToursDocument, options);
      }
export function useToursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ToursQuery, ToursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ToursQuery, ToursQueryVariables>(ToursDocument, options);
        }
export function useToursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ToursQuery, ToursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ToursQuery, ToursQueryVariables>(ToursDocument, options);
        }
export type ToursQueryHookResult = ReturnType<typeof useToursQuery>;
export type ToursLazyQueryHookResult = ReturnType<typeof useToursLazyQuery>;
export type ToursSuspenseQueryHookResult = ReturnType<typeof useToursSuspenseQuery>;
export type ToursQueryResult = Apollo.QueryResult<ToursQuery, ToursQueryVariables>;
export const TourFullDocument = gql`
    query tourFull($id: String!, $modeId: String!) {
  tour(id: $id) {
    id
    status
    title
    subtitle
    description
    keyvisual {
      ...FileData
    }
    texts
    mode(id: $modeId) {
      id
      title
      ageFrom
      ageTo
      duration
      distance
      contributors
      texts
      config
      theme
      files {
        ...FileData
      }
      pois {
        ...TourPoiFull
      }
    }
  }
}
    ${FileDataFragmentDoc}
${TourPoiFullFragmentDoc}`;

/**
 * __useTourFullQuery__
 *
 * To run a query within a React component, call `useTourFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourFullQuery({
 *   variables: {
 *      id: // value for 'id'
 *      modeId: // value for 'modeId'
 *   },
 * });
 */
export function useTourFullQuery(baseOptions: Apollo.QueryHookOptions<TourFullQuery, TourFullQueryVariables> & ({ variables: TourFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourFullQuery, TourFullQueryVariables>(TourFullDocument, options);
      }
export function useTourFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourFullQuery, TourFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourFullQuery, TourFullQueryVariables>(TourFullDocument, options);
        }
export function useTourFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TourFullQuery, TourFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TourFullQuery, TourFullQueryVariables>(TourFullDocument, options);
        }
export type TourFullQueryHookResult = ReturnType<typeof useTourFullQuery>;
export type TourFullLazyQueryHookResult = ReturnType<typeof useTourFullLazyQuery>;
export type TourFullSuspenseQueryHookResult = ReturnType<typeof useTourFullSuspenseQuery>;
export type TourFullQueryResult = Apollo.QueryResult<TourFullQuery, TourFullQueryVariables>;
export const TourDocument = gql`
    query tour($id: String!) {
  tour(id: $id) {
    ...TourDataMinimal
    ratings(limit: 5) {
      ...TourRatingMinimal
    }
  }
}
    ${TourDataMinimalFragmentDoc}
${TourRatingMinimalFragmentDoc}`;

/**
 * __useTourQuery__
 *
 * To run a query within a React component, call `useTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTourQuery(baseOptions: Apollo.QueryHookOptions<TourQuery, TourQueryVariables> & ({ variables: TourQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourQuery, TourQueryVariables>(TourDocument, options);
      }
export function useTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourQuery, TourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourQuery, TourQueryVariables>(TourDocument, options);
        }
export function useTourSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TourQuery, TourQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TourQuery, TourQueryVariables>(TourDocument, options);
        }
export type TourQueryHookResult = ReturnType<typeof useTourQuery>;
export type TourLazyQueryHookResult = ReturnType<typeof useTourLazyQuery>;
export type TourSuspenseQueryHookResult = ReturnType<typeof useTourSuspenseQuery>;
export type TourQueryResult = Apollo.QueryResult<TourQuery, TourQueryVariables>;
export const TourTitleDocument = gql`
    query tourTitle($id: String!) {
  tour(id: $id) {
    id
    title
    keyvisual {
      ...FileData
    }
  }
}
    ${FileDataFragmentDoc}`;

/**
 * __useTourTitleQuery__
 *
 * To run a query within a React component, call `useTourTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourTitleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTourTitleQuery(baseOptions: Apollo.QueryHookOptions<TourTitleQuery, TourTitleQueryVariables> & ({ variables: TourTitleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourTitleQuery, TourTitleQueryVariables>(TourTitleDocument, options);
      }
export function useTourTitleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourTitleQuery, TourTitleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourTitleQuery, TourTitleQueryVariables>(TourTitleDocument, options);
        }
export function useTourTitleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TourTitleQuery, TourTitleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TourTitleQuery, TourTitleQueryVariables>(TourTitleDocument, options);
        }
export type TourTitleQueryHookResult = ReturnType<typeof useTourTitleQuery>;
export type TourTitleLazyQueryHookResult = ReturnType<typeof useTourTitleLazyQuery>;
export type TourTitleSuspenseQueryHookResult = ReturnType<typeof useTourTitleSuspenseQuery>;
export type TourTitleQueryResult = Apollo.QueryResult<TourTitleQuery, TourTitleQueryVariables>;
export const TourModeDocument = gql`
    query tourMode($id: String!) {
  tourMode(id: $id) {
    id
    title
    accessibilityFeatures
    ageFrom
    ageTo
    duration
    distance
    contributors
    texts
    config
    theme
    type
    files {
      ...FileData
    }
    pois {
      ...TourPoiFull
    }
    files {
      ...FileData
    }
  }
}
    ${FileDataFragmentDoc}
${TourPoiFullFragmentDoc}`;

/**
 * __useTourModeQuery__
 *
 * To run a query within a React component, call `useTourModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTourModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTourModeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTourModeQuery(baseOptions: Apollo.QueryHookOptions<TourModeQuery, TourModeQueryVariables> & ({ variables: TourModeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TourModeQuery, TourModeQueryVariables>(TourModeDocument, options);
      }
export function useTourModeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TourModeQuery, TourModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TourModeQuery, TourModeQueryVariables>(TourModeDocument, options);
        }
export function useTourModeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TourModeQuery, TourModeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TourModeQuery, TourModeQueryVariables>(TourModeDocument, options);
        }
export type TourModeQueryHookResult = ReturnType<typeof useTourModeQuery>;
export type TourModeLazyQueryHookResult = ReturnType<typeof useTourModeLazyQuery>;
export type TourModeSuspenseQueryHookResult = ReturnType<typeof useTourModeSuspenseQuery>;
export type TourModeQueryResult = Apollo.QueryResult<TourModeQuery, TourModeQueryVariables>;
export const CreateTourDocument = gql`
    mutation createTour($data: CreateTourInput!) {
  createTour(data: $data) {
    ...TourDataMinimal
  }
}
    ${TourDataMinimalFragmentDoc}`;
export type CreateTourMutationFn = Apollo.MutationFunction<CreateTourMutation, CreateTourMutationVariables>;

/**
 * __useCreateTourMutation__
 *
 * To run a mutation, you first call `useCreateTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourMutation, { data, loading, error }] = useCreateTourMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTourMutation(baseOptions?: Apollo.MutationHookOptions<CreateTourMutation, CreateTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTourMutation, CreateTourMutationVariables>(CreateTourDocument, options);
      }
export type CreateTourMutationHookResult = ReturnType<typeof useCreateTourMutation>;
export type CreateTourMutationResult = Apollo.MutationResult<CreateTourMutation>;
export type CreateTourMutationOptions = Apollo.BaseMutationOptions<CreateTourMutation, CreateTourMutationVariables>;
export const UpdateTourDocument = gql`
    mutation updateTour($data: UpdateTourInput!, $id: String!) {
  updateTour(data: $data, id: $id) {
    ...TourDataMinimal
  }
}
    ${TourDataMinimalFragmentDoc}`;
export type UpdateTourMutationFn = Apollo.MutationFunction<UpdateTourMutation, UpdateTourMutationVariables>;

/**
 * __useUpdateTourMutation__
 *
 * To run a mutation, you first call `useUpdateTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourMutation, { data, loading, error }] = useUpdateTourMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTourMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTourMutation, UpdateTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTourMutation, UpdateTourMutationVariables>(UpdateTourDocument, options);
      }
export type UpdateTourMutationHookResult = ReturnType<typeof useUpdateTourMutation>;
export type UpdateTourMutationResult = Apollo.MutationResult<UpdateTourMutation>;
export type UpdateTourMutationOptions = Apollo.BaseMutationOptions<UpdateTourMutation, UpdateTourMutationVariables>;
export const DeleteTourDocument = gql`
    mutation deleteTour($id: String!) {
  deleteTour(id: $id)
}
    `;
export type DeleteTourMutationFn = Apollo.MutationFunction<DeleteTourMutation, DeleteTourMutationVariables>;

/**
 * __useDeleteTourMutation__
 *
 * To run a mutation, you first call `useDeleteTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTourMutation, { data, loading, error }] = useDeleteTourMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTourMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTourMutation, DeleteTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTourMutation, DeleteTourMutationVariables>(DeleteTourDocument, options);
      }
export type DeleteTourMutationHookResult = ReturnType<typeof useDeleteTourMutation>;
export type DeleteTourMutationResult = Apollo.MutationResult<DeleteTourMutation>;
export type DeleteTourMutationOptions = Apollo.BaseMutationOptions<DeleteTourMutation, DeleteTourMutationVariables>;
export const CreateTourModeDocument = gql`
    mutation createTourMode($data: CreateTourModeInput!) {
  createTourMode(data: $data) {
    id
  }
}
    `;
export type CreateTourModeMutationFn = Apollo.MutationFunction<CreateTourModeMutation, CreateTourModeMutationVariables>;

/**
 * __useCreateTourModeMutation__
 *
 * To run a mutation, you first call `useCreateTourModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTourModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTourModeMutation, { data, loading, error }] = useCreateTourModeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateTourModeMutation(baseOptions?: Apollo.MutationHookOptions<CreateTourModeMutation, CreateTourModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTourModeMutation, CreateTourModeMutationVariables>(CreateTourModeDocument, options);
      }
export type CreateTourModeMutationHookResult = ReturnType<typeof useCreateTourModeMutation>;
export type CreateTourModeMutationResult = Apollo.MutationResult<CreateTourModeMutation>;
export type CreateTourModeMutationOptions = Apollo.BaseMutationOptions<CreateTourModeMutation, CreateTourModeMutationVariables>;
export const UpdateTourModeDocument = gql`
    mutation updateTourMode($data: UpdateTourModeInput!, $id: String!) {
  updateTourMode(data: $data, id: $id) {
    id
  }
}
    `;
export type UpdateTourModeMutationFn = Apollo.MutationFunction<UpdateTourModeMutation, UpdateTourModeMutationVariables>;

/**
 * __useUpdateTourModeMutation__
 *
 * To run a mutation, you first call `useUpdateTourModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTourModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTourModeMutation, { data, loading, error }] = useUpdateTourModeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTourModeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTourModeMutation, UpdateTourModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTourModeMutation, UpdateTourModeMutationVariables>(UpdateTourModeDocument, options);
      }
export type UpdateTourModeMutationHookResult = ReturnType<typeof useUpdateTourModeMutation>;
export type UpdateTourModeMutationResult = Apollo.MutationResult<UpdateTourModeMutation>;
export type UpdateTourModeMutationOptions = Apollo.BaseMutationOptions<UpdateTourModeMutation, UpdateTourModeMutationVariables>;
export const CanUpdateTourModeDocument = gql`
    query canUpdateTourMode($id: String!) {
  canUpdateTourMode(id: $id)
}
    `;

/**
 * __useCanUpdateTourModeQuery__
 *
 * To run a query within a React component, call `useCanUpdateTourModeQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanUpdateTourModeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanUpdateTourModeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCanUpdateTourModeQuery(baseOptions: Apollo.QueryHookOptions<CanUpdateTourModeQuery, CanUpdateTourModeQueryVariables> & ({ variables: CanUpdateTourModeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanUpdateTourModeQuery, CanUpdateTourModeQueryVariables>(CanUpdateTourModeDocument, options);
      }
export function useCanUpdateTourModeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanUpdateTourModeQuery, CanUpdateTourModeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanUpdateTourModeQuery, CanUpdateTourModeQueryVariables>(CanUpdateTourModeDocument, options);
        }
export function useCanUpdateTourModeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanUpdateTourModeQuery, CanUpdateTourModeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanUpdateTourModeQuery, CanUpdateTourModeQueryVariables>(CanUpdateTourModeDocument, options);
        }
export type CanUpdateTourModeQueryHookResult = ReturnType<typeof useCanUpdateTourModeQuery>;
export type CanUpdateTourModeLazyQueryHookResult = ReturnType<typeof useCanUpdateTourModeLazyQuery>;
export type CanUpdateTourModeSuspenseQueryHookResult = ReturnType<typeof useCanUpdateTourModeSuspenseQuery>;
export type CanUpdateTourModeQueryResult = Apollo.QueryResult<CanUpdateTourModeQuery, CanUpdateTourModeQueryVariables>;
export const PublishTourModeUpdateDocument = gql`
    mutation publishTourModeUpdate($id: String!) {
  publishTourModeUpdate(id: $id) {
    url
    filesize
  }
}
    `;
export type PublishTourModeUpdateMutationFn = Apollo.MutationFunction<PublishTourModeUpdateMutation, PublishTourModeUpdateMutationVariables>;

/**
 * __usePublishTourModeUpdateMutation__
 *
 * To run a mutation, you first call `usePublishTourModeUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTourModeUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTourModeUpdateMutation, { data, loading, error }] = usePublishTourModeUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublishTourModeUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PublishTourModeUpdateMutation, PublishTourModeUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishTourModeUpdateMutation, PublishTourModeUpdateMutationVariables>(PublishTourModeUpdateDocument, options);
      }
export type PublishTourModeUpdateMutationHookResult = ReturnType<typeof usePublishTourModeUpdateMutation>;
export type PublishTourModeUpdateMutationResult = Apollo.MutationResult<PublishTourModeUpdateMutation>;
export type PublishTourModeUpdateMutationOptions = Apollo.BaseMutationOptions<PublishTourModeUpdateMutation, PublishTourModeUpdateMutationVariables>;
export const DeleteTourModeDocument = gql`
    mutation deleteTourMode($id: String!) {
  deleteTourMode(id: $id)
}
    `;
export type DeleteTourModeMutationFn = Apollo.MutationFunction<DeleteTourModeMutation, DeleteTourModeMutationVariables>;

/**
 * __useDeleteTourModeMutation__
 *
 * To run a mutation, you first call `useDeleteTourModeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTourModeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTourModeMutation, { data, loading, error }] = useDeleteTourModeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTourModeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTourModeMutation, DeleteTourModeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTourModeMutation, DeleteTourModeMutationVariables>(DeleteTourModeDocument, options);
      }
export type DeleteTourModeMutationHookResult = ReturnType<typeof useDeleteTourModeMutation>;
export type DeleteTourModeMutationResult = Apollo.MutationResult<DeleteTourModeMutation>;
export type DeleteTourModeMutationOptions = Apollo.BaseMutationOptions<DeleteTourModeMutation, DeleteTourModeMutationVariables>;
export const ImportTourDocument = gql`
    mutation importTour($file: Upload!) {
  importTour(file: $file) {
    ...TourDataMinimal
    ratings(limit: 5) {
      ...TourRatingMinimal
    }
  }
}
    ${TourDataMinimalFragmentDoc}
${TourRatingMinimalFragmentDoc}`;
export type ImportTourMutationFn = Apollo.MutationFunction<ImportTourMutation, ImportTourMutationVariables>;

/**
 * __useImportTourMutation__
 *
 * To run a mutation, you first call `useImportTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTourMutation, { data, loading, error }] = useImportTourMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportTourMutation(baseOptions?: Apollo.MutationHookOptions<ImportTourMutation, ImportTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTourMutation, ImportTourMutationVariables>(ImportTourDocument, options);
      }
export type ImportTourMutationHookResult = ReturnType<typeof useImportTourMutation>;
export type ImportTourMutationResult = Apollo.MutationResult<ImportTourMutation>;
export type ImportTourMutationOptions = Apollo.BaseMutationOptions<ImportTourMutation, ImportTourMutationVariables>;
export const ImportTranslationsDocument = gql`
    mutation importTranslations($language: String!, $file: Upload!) {
  importTranslations(language: $language, file: $file) {
    added
    updated
    unchanged
  }
}
    `;
export type ImportTranslationsMutationFn = Apollo.MutationFunction<ImportTranslationsMutation, ImportTranslationsMutationVariables>;

/**
 * __useImportTranslationsMutation__
 *
 * To run a mutation, you first call `useImportTranslationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTranslationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTranslationsMutation, { data, loading, error }] = useImportTranslationsMutation({
 *   variables: {
 *      language: // value for 'language'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportTranslationsMutation(baseOptions?: Apollo.MutationHookOptions<ImportTranslationsMutation, ImportTranslationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTranslationsMutation, ImportTranslationsMutationVariables>(ImportTranslationsDocument, options);
      }
export type ImportTranslationsMutationHookResult = ReturnType<typeof useImportTranslationsMutation>;
export type ImportTranslationsMutationResult = Apollo.MutationResult<ImportTranslationsMutation>;
export type ImportTranslationsMutationOptions = Apollo.BaseMutationOptions<ImportTranslationsMutation, ImportTranslationsMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    